<template>
  <div class="header-space">
    <div v-if="showLoginForm == true">
      <LoginForm
        isFromBooking="Yes"
        @changeUserLoginStatus="ChangeLoginStatus($event)"
      />
    </div>
    <div v-else>
      <section
        class="container header-space min-vh-100 py-5 emp_new_modal mb-5 px-md-3"
      >
        <div class="mb-3 seatlayout-timer">
          <div class="centerTitle">
            <span class="red-dotl"></span>
            <div
              class="d-flex justify-content-center align-items-center"
              v-if="showTimer == true"
            >
              <p class="title ar-number">
                {{ this.timer.minutes }}:{{ this.timer.seconds }}
              </p>
              <p class="text ml-1 ml-md-3">
                <span class="d-block">{{ allLanguageData.Timer[0] }}</span>
                {{ allLanguageData.Timer[1] }}
              </p>
            </div>
            <span class="red-dotr"></span>
          </div>
        </div>
        <div
          class="col-12 col-md-12 mx-auto px-0 bg-white mb-5 new-checkout-box confirmation-box"
        >
          <div
            class="newCheckoutHeader p-3 bg-danger font-weight-bold text-white newEmpRedBG"
          >
            {{ allLanguageData.Confirmation }}
            <!-- <span class="text-right"> {{ scheduleData.cinemaname }}</span> -->
          </div>
          <div class="col-12 col-md-11 col-lg-9 mx-auto pt-4">
            <h5 class="pb-2 font-weight-bold text-center">
              {{ scheduleData.cinemaname }}
            </h5>
            <div class="new-ticket-section my-4">
              <div class="checkout-grid-col mb-3 px-3">
                <div
                  class="first-col font-weight-bold"
                  :class="
                    LanguageID == '1' && LanguageID == 1 ? 'text-right' : ''
                  "
                >
                  {{ allLanguageData.Tickets }}
                  <br />
                  <small>( {{ scheduleData.movie_name }} )<br /></small>
                </div>
                <div class="second-col text-center ar-number">
                  <br />
                  X {{ scheduleData.totalseatcount }}
                </div>
                <div
                  class="third-col font-weight-bold"
                  :class="
                    LanguageID == '1' && LanguageID == 1
                      ? 'text-left'
                      : 'text-right'
                  "
                >
                  <span class="font-weight-normal mr-1 ar-number">
                    {{ scheduleData.currency }} {{ scheduleData.amount }}
                  </span>
                </div>
              </div>
              <div
                v-if="fnbItemDataArry.length > 0"
                class="checkout-grid-col mb-3 px-3"
              >
                <div
                  class="first-col"
                  :class="
                    LanguageID == '1' && LanguageID == 1 ? 'text-right' : ''
                  "
                >
                  <span class="font-weight-bold">
                    {{ allLanguageData.food_n_beverages }} </span
                  ><br />
                  <small v-for="(data, idx) in fnbItemDataArry" :key="idx"
                    >( {{ data.qty }} X {{ data.title }} )<br
                  /></small>
                </div>
                <div class="second-col text-center">
                  <!-- X {{ fnbItemDataArry.length }} -->
                </div>
                <div
                  class="third-col"
                  :class="
                    LanguageID == '1' && LanguageID == 1
                      ? 'text-left'
                      : 'text-right'
                  "
                >
                  <span class="font-weight-normal mr-1 ar-number">
                    {{ scheduleData.currency }} {{ scheduleData.fnb_total }}
                  </span>
                </div>
              </div>

              <div
                v-if="add_ons_array.length > 0"
                class="checkout-grid-col mb-3 px-3"
              >
                <div
                  class="first-col"
                  :class="
                    LanguageID == '1' && LanguageID == 1 ? 'text-right' : ''
                  "
                >
                  <span class="font-weight-bold">
                    {{ allLanguageData.Addons }} </span
                  ><br />
                  <small v-for="(data, idx) in add_ons_array" :key="idx"
                    >{{ data.addons_name }} ( {{ data.quantity }} X
                    {{ data.single_add_ons_price }}
                    {{ scheduleData.currency }} )<br
                  /></small>
                </div>
                <div class="second-col text-center">
                  <!-- X {{ fnbItemDataArry.length }} -->
                </div>
                <div
                  class="third-col"
                  :class="
                    LanguageID == '1' && LanguageID == 1
                      ? 'text-left'
                      : 'text-right'
                  "
                >
                  <span class="font-weight-normal mr-1 ar-number">
                    {{ scheduleData.currency }} {{ add_ons_total }}
                  </span>
                </div>
              </div>

              <div
                class="checkout-grid-col mb-3 px-3"
                v-if="internet_handling_fees"
              >
                <div
                  class="first-col font-weight-bold"
                  :class="
                    LanguageID == '1' && LanguageID == 1 ? 'text-right' : ''
                  "
                >
                  {{ allLanguageData.InternetHF }}
                </div>
                <div class="second-col text-center ar-number">
                  X {{ scheduleData.totalseatcount }}
                </div>
                <div
                  class="third-col"
                  :class="
                    LanguageID == '1' && LanguageID == 1
                      ? 'text-left'
                      : 'text-right'
                  "
                >
                  <span class="font-weight-normal mr-1 ar-number">
                    {{ scheduleData.currency }}
                    {{ scheduleData.total_internet_handling_amt }}
                  </span>
                </div>
              </div>
              <div
                v-if="showDiscounttag == true"
                class="checkout-grid-col mb-3 px-3"
              >
                <div
                  class="first-col font-weight-bold"
                  :class="
                    LanguageID == '1' && LanguageID == 1 ? 'text-right' : ''
                  "
                >
                  {{ allLanguageData.appliedOffers }}

                  <br />
                  <span
                    ><small>( {{ appliedPromoName }} )</small></span
                  >
                </div>
                <div class="second-col text-center"></div>
                <div
                  class="third-col"
                  :class="
                    LanguageID == '1' && LanguageID == 1
                      ? 'text-left'
                      : 'text-right'
                  "
                >
                  <span class="font-weight-normal mr-1 ar-number">
                    {{ scheduleData.currency }}
                    -{{
                      currFormat(
                        getSafe(
                          () => appliedBrijVoucher.BoxOffice.TotalOfferPrice,
                          0
                        ) ||
                          getSafe(
                            () =>
                              showRedeemAmountTab && giftCardRedeemValue
                                ? parseFloat(giftCardRedeemValue)
                                : 0,
                            0
                          )
                      )
                    }}
                  </span>
                </div>
              </div>
              <div v-if="eWalletApplied" class="checkout-grid-col mb-3 px-3">
                <div
                  class="first-col font-weight-bold"
                  :class="
                    LanguageID == '1' && LanguageID == 1 ? 'text-right' : ''
                  "
                >
                  Ewallet Applied

                  <!-- <br />
                  <span
                    ><small>( {{ appliedPromoName }} )</small></span
                  > -->
                </div>
                <div class="second-col text-center"></div>
                <div
                  class="third-col"
                  :class="
                    LanguageID == '1' && LanguageID == 1
                      ? 'text-left'
                      : 'text-right'
                  "
                >
                  <span class="font-weight-normal mr-1 ar-number">
                    {{ scheduleData.currency }}
                    -{{ currFormat(getSafe(() => eWalletAmount, 0)) }}
                  </span>
                </div>
              </div>
              <hr class="border-top border-dark" />
            </div>
            <!-- ********************************* ACCORION - TABS ************************************* -->

            <div
              class="col-12 col-md-11 col-lg-12 px-0 mx-auto my-4 offer-accordion md-accordion"
            >
              <div class="accordion" role="tablist">
                <b-card no-body class="mb-3">
                  <b-card-header header-tag="header" role="tab">
                    <b-button block v-b-toggle.accordion1 variant="none">
                      {{ allLanguageData.OFFERS }}
                    </b-button>
                  </b-card-header>
                  <b-collapse
                    visible
                    id="accordion1"
                    accordion="my-accordion"
                    role="tabpanel"
                    @click="showOffersDetails"
                  >
                    <b-card-body>
                      <div class="offer-box-shadow h-100">
                        <div class="p-2 text-center">
                          <!-- <h4 class="font-weight-bold text-uppercase">{{ allLanguageData.OFFERS }}</h4> -->
                          <p class="mb-0">
                            {{ allLanguageData.SelectOffersTxt }}
                          </p>
                          <router-link
                            class="new-emp-red small font-weight-bold"
                            to="/cinema-offer"
                          >
                            ({{ allLanguageData.TermsConditions }})</router-link
                          >.
                        </div>
                        <div class="checkout-offers-box mt-2">
                          <b-card no-body>
                            <b-tabs card v-model="step">
                              <!-- BANK OFFERS TAB START -->
                              <b-tab
                                v-for="(offerType,
                                offerTypeIndex) in offerTitle"
                                :key="offerTypeIndex"
                                :title="offerType.OfferName"
                                @click="showOffersDetails(offerType)"
                                class="offer-scroll-box"
                              >
                                <div
                                  class=""
                                  v-if="offerListDetails.length > 0"
                                >
                                  <div class="row mx-0 pt-3">
                                    <div
                                      v-for="(offerData,
                                      indx) in offerListDetails"
                                      :key="indx"
                                      class="col-12 col-md-6 col-lg-4 h-100 mb-3"
                                    >
                                      <div
                                        class="offer-card"
                                        @click="
                                          showDiscounttag == false
                                            ? reserveSelectedOfferPromotion(
                                                offerData,
                                                '',
                                                indx
                                              )
                                            : ''
                                        "
                                        :class="
                                          showDiscounttag == true &&
                                          indx == Offerindex &&
                                          appliedOfferType != '4'
                                            ? 'show-applied'
                                            : 'remove-applied'
                                        "
                                      >
                                        <!-- <b-button
                                        :disabled="
                                          showDiscounttag == true ? true : false
                                        "
                                        variant="outline-info"
                                      > -->
                                        <div class="offer-card-txt py-3">
                                          {{
                                            getLangSpecificAttribute(
                                              offerData.details.OfferContent,
                                              getCurrentLang().brij_lang_id,
                                              "offer_title"
                                            ) ||
                                              getSafe(
                                                () =>
                                                  offer.details.OfferContent[0]
                                                    .offer_title
                                              ) ||
                                              getSafe(
                                                () =>
                                                  offer.details.OfferContent[1]
                                                    .offer_title
                                              ) ||
                                              getSafe(
                                                () =>
                                                  offer.details.OfferContent[2]
                                                    .offer_title
                                              )
                                          }}
                                        </div>
                                        <div class="applied-text">✓</div>
                                        <!-- </b-button> -->
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div
                                  v-else
                                  class="offer-scroll-box d-flex align-items-center justify-content-center"
                                >
                                  <h6
                                    v-if="showOfferLoading == true"
                                    class="text-center text-muted my-5"
                                  >
                                    {{ allLanguageData.FetchingOffers }}
                                    <div class="spinner-border"></div>
                                  </h6>
                                  <h6
                                    v-else
                                    class="text-center text-muted my-5"
                                  >
                                    {{ allLanguageData.NoOffers }}
                                  </h6>
                                </div>
                              </b-tab>
                              <!-- BANK OFFERS TAB END -->
                            </b-tabs>
                          </b-card>

                          <div
                            class="offer-error-msg font-weight-bold text-danger"
                            v-if="cardInputErrorMsg && appliedOfferType != '4'"
                          >
                            {{ cardInputErrorMsg }}
                          </div>
                        </div>
                      </div>
                    </b-card-body>
                  </b-collapse>
                </b-card>
                <b-card no-body class="mb-3">
                  <b-card-header header-tag="header" role="tab">
                    <b-button block v-b-toggle.accordion-2 variant="none">
                      {{ allLanguageData.VoucherCode }}
                      <span class="small d-block">{{
                        allLanguageData.EnterCode
                      }}</span>
                    </b-button>
                  </b-card-header>
                  <b-collapse
                    visible
                    id="accordion-2"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <div class="px-3 col-md-10 mx-auto my-5">
                        <h5
                          class="mb-3 font-weight-bold text-center text-uppercase"
                        >
                          {{ allLanguageData.AddVoucherCode }}
                        </h5>
                        <input
                          type="text"
                          :placeholder="allLanguageData.EnterVoucherCode"
                          v-model="promoCodeValue"
                          class="offer-input"
                        />
                        <!-- IF RESPONSE IS SUCCESS USE 'text-success' / 'text-danger' -->
                        <div
                          class="offer-error-msg font-weight-bold text-danger"
                          v-if="cardInputErrorMsg && appliedOfferType == '4'"
                        >
                          {{ cardInputErrorMsg }}
                        </div>
                        <div
                          class="offer-error-msg text-success font-weight-bold"
                          v-if="cardInputsuccessMsg && appliedOfferType == '4'"
                        >
                          {{ cardInputsuccessMsg }}
                        </div>

                        <div class="text-center mx-auto mt-3">
                          <div
                            :class="promoCodeValue ? '' : 'disabled'"
                            class="btn emp-grey-btn"
                            @click="reserveSelectedVoucher(null, 4, '0')"
                          >
                            {{ allLanguageData.ApplyOffer }}
                          </div>
                        </div>
                      </div>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <b-card
                  no-body
                  class="mb-3"
                  v-if="
                    customer_id &&
                      LoyalityDetails['available_loyality_balance'] &&
                      UPP_LOYALITY_PM_ACTIVE
                  "
                >
                  <b-card-header header-tag="header" role="tab">
                    <b-button block v-b-toggle.accordion-4 variant="none">
                      {{ `${allLanguageData.UppLoyality}` }}
                      <span class="small d-block">{{ "" }}</span>
                    </b-button>
                  </b-card-header>

                  <b-collapse
                    visible
                    id="accordion-4"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <div
                        class="px-3 col-md-10 mx-auto my-5"
                        v-if="LoyalityDetails['isLoyalityApplied']"
                      >
                        <h6
                          class="font-weight-bold text-center text-uppercase text-success"
                        >
                          {{ `${allLanguageData.LoyalityApplied}` }}
                        </h6>
                        <div class="mb-3 font-weight-bold text-center fs-16">
                          {{
                            parseInt(LoyalityDetails["total_redeemable_points"])
                          }}
                          <span>pts.</span>
                          <span class="text-uppercase"
                            >({{
                              currFormat(LoyalityDetails["loyality_amount"])
                            }}
                            {{ curr_code || "SAR" }})</span
                          >
                        </div>

                        <div class="text-center mx-auto mt-3">
                          <div class="btn emp-grey-btn" @click="removeLoyality">
                            {{ `${allLanguageData.Remove}` }}
                          </div>
                        </div>
                      </div>

                      <div class="px-3 col-md-10 mx-auto my-5" v-else>
                        <div
                          class="row"
                          :class="langName == 'ar' ? 'flex-row-reverse' : ''"
                        >
                          <div
                            class="col-md-12 col-xl-6 Btitle lrPadding mb-2"
                            colspan="5"
                            style="text-transform: uppercase"
                          >
                            <img
                              src="@/assets/img/newImages/right-red-arrow.svg"
                              :class="langName == 'ar' ? 'ml-1' : 'mr-1'"
                              height="15px"
                              width="15px"
                              alt=""
                            />
                            <!-- {{ allLanguageData.UpComingBookings }} -->
                            {{ allLanguageData.your_tier }}:
                            <span class="">{{
                              parseInt(
                                LoyalityDetails["available_loyality_points"]
                              ) <= 1499
                                ? allLanguageData.Loyalty.redWord
                                : allLanguageData.Loyalty.goldWord
                            }}</span>
                            <br />
                            <img
                              src="@/assets/img/newImages/right-red-arrow.svg"
                              :class="langName == 'ar' ? 'ml-1' : 'mr-1'"
                              style="visibility: hidden"
                              height="15px"
                              width="15px"
                              alt=""
                            />
                            {{ allLanguageData.your_current_balance }}:&nbsp;{{
                              parseInt(
                                LoyalityDetails["available_loyality_points"]
                              )
                            }}
                          </div>

                          <div class="col-md-12 col-xl-6">
                            <p style="color: #cf1f2e; margin-bottom: 3px">
                              *&nbsp;{{ allLanguageData.mini_point }}
                            </p>

                            <!-- <p
                              :style="
                                LoyalityDetails.isRed
                                  ? 'color:#cf1f2e'
                                  : 'color:#c3922e'
                              "
                              style="margin-bottom: 3px;"
                              >*&nbsp;{{ allLanguageData.mini_point }}</p
                            > -->
                            <!-- <p
                              :style="
                                LoyalityDetails.isRed
                                  ? 'color:#cf1f2e'
                                  : 'color:#c3922e'
                              "
                              >*&nbsp;{{
                                LoyalityDetails["isRed"]
                                  ? allLanguageData.thirty_pts
                                  : allLanguageData.twenty_pts
                              }}</p
                            >  -->
                          </div>
                        </div>
                        <h5
                          class="mb-3 font-weight-bold text-center"
                          v-if="false"
                        >
                          <span class="text-uppercase">{{
                            `${allLanguageData.LoyalityPoints}`
                          }}</span>
                          {{
                            parseInt(
                              LoyalityDetails["available_loyality_points"]
                            )
                          }}
                          <span>pts.</span>
                          <!-- <span class="text-uppercase"
                            >({{
                              currFormat(
                                LoyalityDetails["available_loyality_balance"]
                              )
                            }}
                            {{ curr_code || "SAR" }})</span
                          > -->
                        </h5>
                        <!-- <h6 class="mb-3 font-weight-bold text-center">
                          <span>1 pts. = {{currFormat(LoyalityDetails["point_rate"])}}&nbsp;{{ curr_code || "SAR" }}</span>
                        </h6> -->
                        <input
                          type="number"
                          :placeholder="
                            `${allLanguageData.EnterLoyalityPointsNew}`
                          "
                          v-model="LoyalityDetails['total_redeemable_points']"
                          class="offer-input"
                        />
                        <!-- <div class="mb-3 font-weight-bold text-center fs-16">
                          <span class="text-uppercase"
                            >{{ `${allLanguageData.LoyalityRedeem}` }} </span
                          >=
                          {{
                            currFormat(
                              LoyalityDetails["total_redeemable_points"]
                            )
                          }}
                          <span>pts.</span>
                          <span class="text-uppercase"
                            >({{
                              currFormat(LoyalityDetails["loyality_amount"])
                            }}
                            {{ curr_code || "SAR" }})</span
                          >
                        </div> -->
                        <div
                          class="offer-error-msg font-weight-bold text-danger"
                          v-if="LoyalityDetails['ErrorMsg']"
                        >
                          {{ LoyalityDetails["ErrorMsg"] }}
                        </div>

                        <div
                          class="offer-error-msg text-success font-weight-bold"
                          v-if="LoyalityDetails['SuccessMsg']"
                        >
                          {{ LoyalityDetails["SuccessMsg"] }}
                        </div>

                        <div class="text-center mx-auto mt-3">
                          <div
                            class="btn emp-grey-btn"
                            @click="applyLoyality($event, 4)"
                          >
                            {{ `${allLanguageData.APPLY}` }}
                          </div>
                        </div>
                      </div>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <b-card
                  no-body
                  class="mb-3"
                  v-if="
                    activePaymentModes.some((p) => p.pm_id == 23) &&
                      !eWalletApplied
                  "
                >
                  <b-card-header header-tag="header" role="tab">
                    <b-button block v-b-toggle.accordion-3 variant="none">
                      {{ `${allLanguageData.GiftCard}` }}
                      <span class="small d-block">{{ "" }}</span>
                    </b-button>
                  </b-card-header>

                  <b-collapse
                    visible
                    id="accordion-3"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <div
                        class="px-3 col-md-10 mx-auto my-5"
                        v-if="showRedeemAmountTab && giftCardRedeemValue"
                      >
                        <h5
                          class="mb-3 font-weight-bold text-center text-uppercase"
                        >
                          {{
                            `${
                              allLanguageData.GiftCardAmountToRedeem
                            }: ${getSafe(
                              () =>
                                giftCardDetails.cardDetails.giftcard_currency,
                              "SAR"
                            )} ${giftCardRedeemValue}`
                          }}
                        </h5>

                        <div class="text-center mx-auto mt-3">
                          <div
                            class="btn emp-grey-btn"
                            @click="removeAddedOffer"
                          >
                            {{ `${allLanguageData.Remove}` }}
                          </div>
                        </div>
                      </div>
                      <!---->
                      <div
                        class="px-3 col-md-10 mx-auto my-5"
                        v-else-if="
                          !showRedeemAmountTab &&
                            !!giftCardDetails &&
                            giftCardDetails.balance
                        "
                      >
                        <h5
                          class="mb-3 font-weight-bold text-center text-uppercase"
                        >
                          {{
                            `${allLanguageData.YourCurrentBalanceIs}: ${getSafe(
                              () =>
                                giftCardDetails.cardDetails.giftcard_currency,
                              "SAR"
                            )} ${giftCardDetails.balance}`
                          }}
                        </h5>
                        <input
                          :disabled="
                            giftCardDetails.balance == '0.0' ||
                              giftCardDetails.balance == '0.00' ||
                              giftCardDetails.balance == 0 ||
                              true
                          "
                          type="text"
                          :placeholder="
                            `${allLanguageData.GiftCardAmountToRedeem}`
                          "
                          :value="giftCardRedeemValue"
                          class="offer-input"
                        />

                        <!--I have REMOVED v-model.number from above input field so no body can inspect and change the value of disbale field because now full amount is required in gift card.-->
                        <!-- IF RESPONSE IS SUCCESS USE 'text-success' / 'text-danger' -->
                        <div
                          class="offer-error-msg font-weight-bold text-danger"
                          v-if="giftCardErrorMsg"
                        >
                          {{ giftCardErrorMsg }}
                        </div>

                        <div
                          class="offer-error-msg text-success font-weight-bold"
                          v-if="giftCardInputsuccessMsg"
                        >
                          {{ giftCardInputsuccessMsg }}
                        </div>

                        <div class="text-center mx-auto mt-3">
                          <div
                            class="btn emp-grey-btn"
                            @click="resetGiftCardDetails"
                          >
                            {{ `${allLanguageData.PopupTerms.CancelButton}` }}
                          </div>
                          <div
                            :class="
                              giftCardRedeemValue && giftCardRedeemValue > 0
                                ? ''
                                : 'disabled'
                            "
                            class="btn emp-grey-btn"
                            @click="redeemGiftCard"
                          >
                            {{ `${allLanguageData.Redeem}` }}
                          </div>
                        </div>
                      </div>
                      <!---->
                      <div class="px-3 col-md-10 mx-auto my-5" v-else>
                        <h5
                          class="mb-3 font-weight-bold text-center text-uppercase"
                        >
                          {{ `${allLanguageData.EnterGiftCardNumber}` }}
                        </h5>
                        <input
                          type="text"
                          :placeholder="
                            `${allLanguageData.EnterGiftCardNumber}`
                          "
                          v-model="giftCardNumber"
                          class="offer-input"
                        />
                        <!-- IF RESPONSE IS SUCCESS USE 'text-success' / 'text-danger' -->
                        <div
                          class="offer-error-msg font-weight-bold text-danger"
                          v-if="giftCardErrorMsg"
                        >
                          {{ giftCardErrorMsg }}
                        </div>

                        <div
                          class="offer-error-msg text-success font-weight-bold"
                          v-if="giftCardInputsuccessMsg"
                        >
                          {{ giftCardInputsuccessMsg }}
                        </div>

                        <div class="text-center mx-auto mt-3">
                          <div
                            :class="giftCardNumber ? '' : 'disabled'"
                            class="btn emp-grey-btn"
                            @click="getGiftCardDetails"
                          >
                            {{ `${allLanguageData.GetCardBalance}` }}
                          </div>
                        </div>
                      </div>
                    </b-card-body>
                  </b-collapse>
                </b-card>

                <b-card no-body class="mb-3" v-if="customer_id">
                  <b-card-header header-tag="header" role="tab">
                    <b-button block v-b-toggle.accordion-3 variant="none">
                      {{ `${allLanguageData.Ewallet}` }}
                      <span class="small d-block">{{ "" }}</span>
                    </b-button>
                  </b-card-header>

                  <b-collapse
                    visible
                    id="accordion-3"
                    accordion="my-accordion"
                    role="tabpanel"
                  >
                    <b-card-body>
                      <div
                        class="px-3 col-md-10 mx-auto my-5"
                        v-if="eWalletApplied"
                      >
                        <h5
                          class="mb-3 font-weight-bold text-center text-uppercase"
                        >
                          {{
                            `${allLanguageData.EwalletAmountRedeem}: ${getSafe(
                              () => curr_code,
                              "SAR"
                            )} ${eWalletAmount}`
                          }}
                        </h5>

                        <div class="text-center mx-auto mt-3">
                          <div class="btn emp-grey-btn" @click="removeEwallet">
                            {{ `${allLanguageData.Remove}` }}
                          </div>
                        </div>
                      </div>
                      <!---->

                      <!---->
                      <div class="px-3 col-md-10 mx-auto my-5" v-else>
                        <h5
                          class="mb-3 font-weight-bold text-center text-uppercase"
                        >
                          {{ `${allLanguageData.EwalletPoint}` }}
                          {{ curr_code || "SAR" }}
                          {{ currFormat(ewalletBalance) }}
                        </h5>
                        <input
                          type="number"
                          :placeholder="`${allLanguageData.EnterYourEwallet}`"
                          v-model="eWalletAmount"
                          class="offer-input"
                        />
                        <!-- IF RESPONSE IS SUCCESS USE 'text-success' / 'text-danger' -->
                        <div
                          class="offer-error-msg font-weight-bold text-danger"
                          v-if="ewalletErrorMessage"
                        >
                          {{ ewalletErrorMessage }}
                        </div>

                        <div
                          class="offer-error-msg text-success font-weight-bold"
                          v-if="ewalletSuccessMsg"
                        >
                          {{ ewalletSuccessMsg }}
                        </div>

                        <div class="text-center mx-auto mt-3">
                          <div class="btn emp-grey-btn" @click="applyEwallet">
                            {{ `${allLanguageData.APPLY}` }}
                          </div>
                        </div>
                      </div>
                    </b-card-body>
                  </b-collapse>
                </b-card>
              </div>
            </div>

            <!----End Accordion Tabs------>
          </div>
          <div class="newEmpGreyBG py-2 new-checkout-box-footer">
            <div class="col-12 col-md-10 col-lg-9 mx-auto">
              <div class="row emp_new_modal">
                <div
                  class="col-9 col-md-7 mb-3 mb-md-0"
                  :class="
                    LanguageID == '1' && LanguageID == 1 ? 'text-right' : ''
                  "
                >
                  <p class="mb-1 font-weight-bold">
                    {{ allLanguageData.TotalPayable }}
                  </p>
                  <small class="tax-text d-block">
                    ({{ allLanguageData.IncludesTaxesFees }})
                  </small>
                </div>
                <div
                  class="col-3 col-md-5 align-self-center"
                  :class="
                    LanguageID == '1' && LanguageID == 1
                      ? 'text-left'
                      : 'text-right'
                  "
                >
                  <p class="mb-0 font-weight-bold">
                    <span class="font-weight-normal mr-1 ar-number">
                      {{ scheduleData.currency }}
                    </span>
                    <span class="font-weight-bold ar-number finalTotalDiv2">
                      {{
                        +parseFloat(
                          scheduleData.total_ticket_fnb -
                            getSafe(
                              () =>
                                appliedBrijVoucher.BoxOffice.TotalOfferPrice,
                              0
                            ) -
                            getSafe(
                              () =>
                                showRedeemAmountTab && giftCardRedeemValue
                                  ? parseFloat(giftCardRedeemValue)
                                  : 0,
                              0
                            ) -
                            getSafe(
                              () =>
                                eWalletApplied && eWalletAmount
                                  ? parseFloat(eWalletAmount)
                                  : 0,
                              0
                            ) -
                            getSafe(
                              () =>
                                LoyalityDetails["isLoyalityApplied"] &&
                                LoyalityDetails["loyality_amount"]
                                  ? parseFloat(
                                      LoyalityDetails["loyality_amount"]
                                    )
                                  : 0,
                              0
                            )
                        ).toFixed(2) > 0
                          ? +parseFloat(
                              scheduleData.total_ticket_fnb -
                                getSafe(
                                  () =>
                                    appliedBrijVoucher.BoxOffice
                                      .TotalOfferPrice,
                                  0
                                ) -
                                getSafe(
                                  () =>
                                    showRedeemAmountTab && giftCardRedeemValue
                                      ? parseFloat(giftCardRedeemValue)
                                      : 0,
                                  0
                                ) -
                                getSafe(
                                  () =>
                                    eWalletApplied && eWalletAmount
                                      ? parseFloat(eWalletAmount)
                                      : 0,
                                  0
                                ) -
                                getSafe(
                                  () =>
                                    LoyalityDetails["isLoyalityApplied"] &&
                                    LoyalityDetails["loyality_amount"]
                                      ? parseFloat(
                                          LoyalityDetails["loyality_amount"]
                                        )
                                      : 0,
                                  0
                                )
                            ).toFixed(2)
                          : 0
                      }}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="seat-section-txt pt-4">
          <h5
            class="font-weight-bold text-center text-uppercase mt-3 pb-2 pt-3 px-2 mt-md-5 pt-md-5"
          >
            {{ allLanguageData.ReturnsPolicy }}
          </h5>
          {{ allLanguageData.ReturnsPolicyContent }}
        </div>
      </section>
      <!--Desktop Checkout Grid-->
      <div class="container-fluid checkout-fixed py-4 d-none d-md-block">
        <div class="col-lg-12 mx-auto">
          <div class="align-items-center checkout-grid">
            <div class="text-right" @click="goBack()">
              <img
                src="@/assets/img/new-img/svg-img/back-arrow.svg"
                class=""
                width="40px"
              />
            </div>
            <div class="vertical-line">
              <!-- <hr class="vertical" /> -->
            </div>
            <div class="grid-half">
              <ul class="mb-0 px-0 checkout-list">
                <li class="pb-2" style="color: white">
                  {{ allLanguageData.Movie }}: {{ scheduleData.movie_name }}
                </li>
                <li class="pb-2" style="color: white">
                  {{ allLanguageData.Screen }}: {{ scheduleData.ScreenName }}
                </li>
                <li class="pb-2" style="color: white">
                  {{ allLanguageData.Date }}: {{ scheduleData.date }}
                </li>
                <li class="pb-2" style="color: white">
                  {{ allLanguageData.Time }}: {{ scheduleData.time }}
                </li>
              </ul>
              <ul class="mb-0 px-0 checkout-list">
                <li class="pb-2">
                  {{ allLanguageData.Location }}: {{ scheduleData.cinemaname }}
                </li>
                <li class="pb-2">
                  {{ allLanguageData.Experience }}: {{ scheduleData.exp }}
                </li>
                <li class="pb-2">
                  {{ allLanguageData.Seats }}:
                  <template
                    v-if="normal_seats.length"
                    v-for="seatObj in normal_seats"
                  >
                    <span
                      class="ar-number"
                      :key="seatObj.sst_seat_type + '3'"
                      v-if="seatObj.seatName.length"
                      >{{ seatObj.sst_seat_type }} -
                      {{ seatObj.seatName.join(", ") }} </span
                    ><br
                      :key="seatObj.sst_seat_type + '2'"
                      v-if="seatObj.seatName.length"
                    />
                    <span
                      class="ar-number"
                      v-if="seatObj.wheelChair.length"
                      :key="seatObj.sst_seat_type + '4'"
                      >{{ seatObj.sst_seat_type }} Wheel Chair -
                      {{ seatObj.wheelChair.join(", ") }} </span
                    ><br
                      :key="seatObj.sst_seat_type + '5'"
                      v-if="seatObj.wheelChair.length"
                    />
                  </template>
                </li>
              </ul>
            </div>
            <div class="vertical-line">
              <hr class="vertical" />
            </div>
            <div :class="['finalTotalDiv', scheduleData.total_ticket_fnb]">
              {{ allLanguageData.Total }} : {{ scheduleData.currency }}
              {{
                +parseFloat(
                  scheduleData.total_ticket_fnb -
                    getSafe(
                      () => appliedBrijVoucher.BoxOffice.TotalOfferPrice,
                      0
                    ) -
                    getSafe(
                      () =>
                        showRedeemAmountTab && giftCardRedeemValue
                          ? parseFloat(giftCardRedeemValue)
                          : 0,
                      0
                    ) -
                    getSafe(
                      () =>
                        eWalletApplied && eWalletAmount
                          ? parseFloat(eWalletAmount)
                          : 0,
                      0
                    ) -
                    getSafe(
                      () =>
                        LoyalityDetails["isLoyalityApplied"] &&
                        LoyalityDetails["loyality_amount"]
                          ? parseFloat(LoyalityDetails["loyality_amount"])
                          : 0,
                      0
                    )
                ).toFixed(2) > 0
                  ? +parseFloat(
                      scheduleData.total_ticket_fnb -
                        getSafe(
                          () => appliedBrijVoucher.BoxOffice.TotalOfferPrice,
                          0
                        ) -
                        getSafe(
                          () =>
                            showRedeemAmountTab && giftCardRedeemValue
                              ? parseFloat(giftCardRedeemValue)
                              : 0,
                          0
                        ) -
                        getSafe(
                          () =>
                            eWalletApplied && eWalletAmount
                              ? parseFloat(eWalletAmount)
                              : 0,
                          0
                        ) -
                        getSafe(
                          () =>
                            LoyalityDetails["isLoyalityApplied"] &&
                            LoyalityDetails["loyality_amount"]
                              ? parseFloat(LoyalityDetails["loyality_amount"])
                              : 0,
                          0
                        )
                    ).toFixed(2)
                  : 0
              }}
              <br />
              <div
                v-b-tooltip.hover
                :title="appliedPromoName ? appliedPromoName : ''"
                class="text-center small offerTxt px-1"
                v-if="showDiscounttag == true"
              >
                {{ allLanguageData.OfferApplied }}

                <!-- {{ scheduleData.Discount }} -->

                <span class="removeOffer" @click="removeAddedOffer"
                  ><img
                    src="@/assets/img/svg/close-icon.svg"
                    height="10px"
                    width="10px"
                /></span>
              </div>
              <div
                v-b-tooltip.hover
                :title="eWalletApplied ? 'E-Wallet Applied' : ''"
                class="text-center small offerTxt px-1"
                v-if="eWalletApplied"
              >
                {{ allLanguageData.EwalletApplied }}

                <!-- {{ scheduleData.Discount }} -->

                <span class="removeOffer" @click="removeEwallet"
                  ><img
                    src="@/assets/img/svg/close-icon.svg"
                    height="10px"
                    width="10px"
                /></span>
              </div>
              <div
                v-b-tooltip.hover
                :title="
                  LoyalityDetails['isLoyalityApplied'] ? 'Loyality Applied' : ''
                "
                class="text-center small offerTxt px-1"
                v-if="LoyalityDetails['isLoyalityApplied']"
              >
                {{ allLanguageData.LoyalityApplied }}

                <!-- {{ scheduleData.Discount }} -->

                <span class="removeOffer" @click="removeLoyality"
                  ><img
                    src="@/assets/img/svg/close-icon.svg"
                    height="10px"
                    width="10px"
                /></span>
              </div>
              <!-- <div v-if="showDiscounttag == true">
              <b-button disabled variant="outline-info"
                >OFFER APPLIED : {{ scheduleData.Discount }}
              </b-button>
              <b-button
                size="sm"
                @click="removeAddedOffer"
                variant="outline-danger"
                >remove</b-button
              >
            </div> -->
            </div>
            <div class="vertical-line">
              <hr class="vertical" />
            </div>
            <div>
              <button class="btn btn-checkout" @click="onFinalCheckOut">
                {{ allLanguageData.Checkout }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <!--Mobile Checkout Grid-->
      <div class="container-fluid checkout-fixed py-4 d-block d-md-none">
        <div class="col-lg-12 px-0 mx-auto">
          <div
            class="align-items-center pt-3 animate__animated animate__pulse"
            :class="displayContent ? 'd-block' : 'd-none'"
          >
            <div class="mt-5">
              <ul class="mb-0 px-0 checkout-list">
                <li class="pb-3">
                  <span class="font-weight-bold">MOVIE:</span>
                  {{ scheduleData.movie_name }}
                </li>
                <li class="pb-2">SCREEN: {{ scheduleData.ScreenName }}</li>
                <li class="pb-3">
                  <span class="font-weight-bold">DATE:</span>
                  {{ scheduleData.date }}
                </li>
                <li class="pb-3">
                  <span class="font-weight-bold">TIME:</span>
                  {{ scheduleData.time }}
                </li>
              </ul>
              <ul class="mb-0 px-0 checkout-list">
                <li class="pb-3">
                  <span class="font-weight-bold">LOCATION: </span>
                  {{ scheduleData.cinemaname }}
                </li>
                <li class="pb-3">
                  <span class="font-weight-bold">
                    {{ allLanguageData.Experience }}:</span
                  >
                  {{ scheduleData.exp }}
                </li>
                <hr class="m-0 fade-line no-hover-effect" />
                <li class="py-3 seating-tick">
                  {{ allLanguageData.Seats }}:
                  <template
                    v-if="normal_seats.length"
                    v-for="seatObj in normal_seats"
                  >
                    <span
                      class="ar-number"
                      :key="seatObj.sst_seat_type + '3'"
                      v-if="seatObj.seatName.length"
                      >{{ seatObj.sst_seat_type }} -
                      {{ seatObj.seatName.join(", ") }} </span
                    ><br
                      :key="seatObj.sst_seat_type + '2'"
                      v-if="seatObj.seatName.length"
                    />
                    <span
                      class="ar-number"
                      v-if="seatObj.wheelChair.length"
                      :key="seatObj.sst_seat_type + '4'"
                      >{{ seatObj.sst_seat_type }} Wheel Chair -
                      {{ seatObj.wheelChair.join(", ") }} </span
                    ><br
                      :key="seatObj.sst_seat_type + '5'"
                      v-if="seatObj.wheelChair.length"
                    />
                  </template>
                </li>
                <hr class="m-0 mb-3 fade-line no-hover-effect" />
              </ul>
            </div>
          </div>
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center details-header">
              <div @click="goBack">
                <img
                  src="@/assets/img/new-img/svg-img/back-arrow.svg"
                  class=""
                  width="30px"
                />
              </div>
              <div @click="showContent()" class="ml-3">
                <h6 class="mb-0">INFO</h6>
              </div>
            </div>
            <div
              :class="displayContent ? 'd-block arrow-down' : 'd-none'"
              @click="showContent()"
            >
              <img
                src="@/assets/img/new-img/svg-img/arrow-down.svg"
                class=""
                width="30px"
              />
            </div>
            <div
              class="d-flex align-items-center w-100"
              :class="displayContent ? '' : 'justify-content-end'"
            >
              <h6 class="font-weight-bold mb-0 mr-2">
                TOTAL : {{ scheduleData.currency }}
                {{
                  +parseFloat(
                    scheduleData.total_ticket_fnb -
                      getSafe(
                        () => appliedBrijVoucher.BoxOffice.TotalOfferPrice,
                        0
                      ) -
                      getSafe(
                        () =>
                          showRedeemAmountTab && giftCardRedeemValue
                            ? parseFloat(giftCardRedeemValue)
                            : 0,
                        0
                      ) -
                      getSafe(
                        () =>
                          eWalletApplied && eWalletAmount
                            ? parseFloat(eWalletAmount)
                            : 0,
                        0
                      ) -
                      getSafe(
                        () =>
                          LoyalityDetails["isLoyalityApplied"] &&
                          LoyalityDetails["loyality_amount"]
                            ? parseFloat(LoyalityDetails["loyality_amount"])
                            : 0,
                        0
                      )
                  ).toFixed(2) > 0
                    ? +parseFloat(
                        scheduleData.total_ticket_fnb -
                          getSafe(
                            () => appliedBrijVoucher.BoxOffice.TotalOfferPrice,
                            0
                          ) -
                          getSafe(
                            () =>
                              showRedeemAmountTab && giftCardRedeemValue
                                ? parseFloat(giftCardRedeemValue)
                                : 0,
                            0
                          ) -
                          getSafe(
                            () =>
                              eWalletApplied && eWalletAmount
                                ? parseFloat(eWalletAmount)
                                : 0,
                            0
                          ) -
                          getSafe(
                            () =>
                              LoyalityDetails["isLoyalityApplied"] &&
                              LoyalityDetails["loyality_amount"]
                                ? parseFloat(LoyalityDetails["loyality_amount"])
                                : 0,
                            0
                          )
                      ).toFixed(2)
                    : 0
                }}
              </h6>
              <div :class="displayContent ? 'ml-auto' : ''">
                <button class="btn btn-checkout" @click="onFinalCheckOut">
                  CHECKOUT
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      id="quitBooking"
      ref="quitBooking"
      :title="allLanguageData.QuitBooking.title"
      class="ErModal light-red-color"
    >
      <img
        class="mx-auto d-block mt-4"
        src="@/assets/img/svg/alert-icon.svg"
        width="45"
        height="auto"
      />
      <h6 class="pt-3 mb-0 text-center font-weight-bold text-white">
        {{ allLanguageData.QuitBooking.Content1 }}
      </h6>
      <!-- <h6 class="pt-2 text-center font-weight-bold text-white">{{allLanguageData.ErrorModal.Content2}}!</h6> -->
      <div class="d-flex justify-content-center align-items-center">
        <div class>
          <b-button
            v-on:click="goBackHistory()"
            variant="default"
            :class="preimere == 'true' ? 'btn-proceed' : 'btn-green'"
            class="btn mt-4 mb-3"
            >{{ allLanguageData.QuitBooking.Btn }}</b-button
          >
        </div>
        <div class="px-2"></div>
        <div class>
          <b-button
            v-on:click="onClickNo()"
            variant="default"
            :class="preimere == 'true' ? 'btn-proceed' : 'btn-green'"
            class="btn mt-4 mb-3"
            >{{ allLanguageData.QuitBooking.Btn1 }}</b-button
          >
        </div>
      </div>
    </b-modal>
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      id="sessionExpired"
      ref="sessionExpired"
      title="Session Expired"
      class="ErModal light-red-color"
    >
      <img
        class="mx-auto d-block mt-4"
        src="@/assets/img/svg/alert-icon.svg"
        width="45"
        height="auto"
      />
      <h6 class="pt-3 mb-0 text-center font-weight-bold text-white">
        Session Expired Please try again.!
      </h6>
      <!-- <h6 class="pt-2 text-center font-weight-bold text-white">{{allLanguageData.ErrorModal.Content2}}!</h6> -->
      <div class="d-flex justify-content-center align-items-center">
        <div class>
          <b-button
            v-on:click="goBackExpired()"
            variant="default"
            :class="preimere == 'true' ? 'btn-proceed' : 'btn-green'"
            class="btn mt-4 mb-3"
            >OK</b-button
          >
        </div>
      </div>
    </b-modal>
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      id="errorModal"
      ref="errorModal"
      title="Booking Failed"
      class="ErModal light-red-color"
    >
      <img
        class="mx-auto d-block mt-4"
        src="@/assets/img/svg/alert-icon.svg"
        width="45"
        height="auto"
      />
      <h6 class="pt-3 mb-0 text-center font-weight-bold text-white">
        {{ this.errorMessage }}...
      </h6>

      <b-button
        @click="onClickOk()"
        variant="default"
        class="btn btn-green mt-4 mb-3"
        >{{ allLanguageData.ErrorModal.Btn }}</b-button
      >
    </b-modal>

    <b-modal
      no-close-on-backdrop
      id="updatedFailPopup"
      ref="updatedFailPopup"
      title="Update Fail"
      class="ErModal light-red-color"
    >
      <h6 class="py-5 mb-0 text-center font-weight-bold text-white">
        {{ 'Profile Update Failed' }}
      </h6>
    </b-modal>
  </div>
</template>

<script>
import { makeRequest, makeRequestBrij } from "@/helper/internet.js";
import Vue from "vue";
import moment from "moment";
import ReactPixel from "react-facebook-pixel";
import ReactSnapPixel from "react-snapchat-pixel";
import { tiktockCheckout } from "@/helper/events";
import LoginForm from "@/components/pages/login.vue";
import { mapState, mapGetters, mapActions } from "vuex";
import {
  LanguageService,
  CountryService,
  TokenService,
} from "@/services/storage.service";
import { metaInfo } from "@/helper/constant.js";
import { parse } from "libphonenumber-js";

export default {
  data() {
    return {
      activePaymentModes: [],
      step: 0,
      preimere: "",
      cardInputErrorMsg: "",

      showRedeemAmountTab: false,
      giftCardRedeemValue: 0,
      giftCardNumber: "",
      giftCardErrorMsg: "",
      giftCardInputsuccessMsg: "",
      giftCardDetails: null,

      errorMessage: "",
      cardInputsuccessMsg: "",
      appliedOfferType: "",
      promoCodeValue: "",
      ReserveID: "",
      appliedPromoName: "",
      wc_seats: "",
      normal_seats: [],
      SeatLable: "",
      Offerindex: "",
      LanguageID: "",
      displayContent: false,
      showOfferLoading: false,
      userDetails: {},
      profileDetails: {},
      showTimer: false,
      selectedSeats: "",
      scheduleData: {
        ScreenName: "",
        Discount: "",
        DiscountRemark: "",
        Fvvtext: "",
        Message: "",
        OfferAmount: "",
        Offeritem: "",
        Status: "",
        TransactionType: "",
        amount: "",
        cinema: "",
        currency: "",
        date: "",
        desc: "",
        exp: "",
        fnb_total: "",
        fnbamount: "",
        fnbvat: "",
        internet_handling_amt: "",
        iscombooffer: "",
        isofferpagedisplay: "",
        movie_image: "",
        movie_name: "",
        time: "",
        screenid: "",
        total_amt: "",
        total_internet_handling_amt: "",
        total_ticket_fnb: "",
        totalfvvamt: "",
        totalseatcount: "",
        cinemaname: "",
        movieid: "",
        scheduleid: "",
      },
      fnbItemDataArry: [],
      offerTitle: [
        {
          OfferID: 45, // mpm_d_id
          OfferName: "Cinema Offer",
        },
      ],
      offerListDetails: [],
      headerTitleId: "1",
      showDiscounttag: false,
      selectedPromotionID: "",
      userLoginStatus: true,
      showLoginForm: false,
      timerStartFunction: null,
      timer: {
        TimeoutModal: false,
        minutes: 9,
        seconds: 59,
        stop: false,
      },
      isSeatReleased: true,
      internet_handling_fees: false,
      reservationDetails: null,
      appliedBrijVoucher: null,
      add_ons_array: [],
      add_ons_total: 0,
      add_ons_array_on_final_price: [],
      fnbItemData: [],
      fnbItemDataTemp: [],
      fnbItems: [],
      FNbPrice: { total_price: 0, total_tax: 0 },
      eWalletAmount: "",
      ewalletSuccessMsg: "",
      ewalletErrorMessage: "",
      ewalletBalance: 2500,
      eWalletApplied: false,
      customer_id: 0,
      LoyalityDetails: {
        isLoyalityApplied: false,
        loyality_amount: 0,
        bo_amount: 0,
        fnb_amount: 0,
        customer_id: null,
        available_loyality_balance: 0,
        available_loyality_points: 0,
        total_redeemable_points: null,
        point_rate: 0,
        bo_redeem_points: 0,
        fnb_redeem_points: 0,
        LoyaltyProgram: "Club Empire",
        ErrorMsg: "",
        SuccessMsg: "",
        isRed: false,
        isGold: false,
      },
    };
  },
  components: {
    LoginForm,
  },
  computed: {
    curr_code() {
      return this.$store.getters.getGlobalCurrency.curr_code || "Sar";
    },
    UPP_LOYALITY_PM_ACTIVE() {
      let status = false;
      status = this.activePaymentModes.some((x) => x.pm_id == 31);
      return status;
    },
    fnb_gross_amount() {
      let amount = 0;
      amount += +parseFloat(this.scheduleData.fnb_total || 0).toFixed(2);
      console.log("amount", amount);
      console.log("this.scheduleData.fnb_total", this.scheduleData.fnb_total);
      return amount;
    },
    ticket_gross_amount() {
      let amount = 0;
      amount = +parseFloat(
        amount +
          parseFloat(this.scheduleData.amount || 0) +
          parseFloat(this.scheduleData.total_internet_handling_amt || 0) +
          parseFloat(this.add_ons_total || 0)
      ).toFixed(2);
      console.log("amount", amount);
      console.log("this.scheduleData.amount", this.scheduleData.amount);
      return amount;
    },
  },
  beforeMount() {
    this.ReserveID = this.$route.params.reserveId;
    this.getReserveInfo(this.ReserveID, "0");
    this.getUserDetailsBrij();
    this.getActivePaymentModes();
    this.getWalletBalance();
    this.getUppLoyalityCustomerBalance();
  },
  mounted: function() {
    let token = TokenService.getToken();
    if (token) {
      this.userLoginStatus = true;
      console.log(token, "hjhjh");
    } else {
      this.userLoginStatus = false;
      console.log(token, "jhj");
    }
    let language = LanguageService.getLanguage();
    if (!language) {
      this.LanguageID = 2;
    } else {
      this.LanguageID = language.lang_id;
    }
    // this.handleResize();
    let lang = LanguageService.getLanguage();
    if (lang == null) {
      this.langName = "eng";
    } else {
      this.langName = lang["lang"];
    }

    // this.getAllOffers();
    // this.$root.$on("bv::collapse::state", (collapseId, isJustShown) => {
    //   this.showOffersDetails();
    //   console.log("collapseId:", collapseId);
    //   console.log("isJustShown:", isJustShown);
    //   if (collapseId == "accordion1" && isJustShown == true) {
    //     this.showOffersDetails();
    //   }
    // });
  },
  beforeRouteLeave(to, from, next) {
    if (this.isSeatReleased) {
      this.callSeatReleased();
    }
    next();
  },
  methods: {
    getWalletBalance() {
      let cust_token = TokenService.getToken();
      if (cust_token) {
        this.customer_id = cust_token;
        makeRequestBrij(`/api/e_wallet/getbalance`, "POST", null, {
          customer_id: cust_token,
          loyalty_details: {},
        }).then((response) => {
          if (response && response.res.data.status) {
            this.ewalletBalance = +parseFloat(
              response.res.data.wallet_balance
            ).toFixed(2);
          } else {
            this.ewalletBalance = +parseFloat(0).toFixed(2);
          }
        });
      }
    },
    getUppLoyalityCustomerBalance() {
      let cust_token = TokenService.getToken();
      if (cust_token) {
        this.customer_id = cust_token;
        // this.showLoading();
        makeRequestBrij(
          `/api/cinema/get_balance/${cust_token}`,
          "GET",
          null,
          null
        )
          .then((response) => {
            if (response && response.res.data.status) {
              console.log("response", response);
              const {
                available_points,
                available_points_amount,
                pointRate = 0,
              } = response.res.data;
              this.LoyalityDetails = {
                ...this.LoyalityDetails,
                available_loyality_points: available_points,
                point_rate: +parseFloat(pointRate).toFixed(2),
                available_loyality_balance: +parseFloat(
                  available_points_amount
                ).toFixed(2),
                isRed: available_points <= 1499,
                isGold: available_points > 1499,
              };
              // if (available_points <= 1499) {
              //   this.isRed = true;
              //   this.isGold = false;
              // } else if (available_points > 1499) {
              //   this.isRed = false;
              //   this.isGold = true;
              // }
            } else {
              this.LoyalityDetails = {
                ...this.LoyalityDetails,
                available_loyality_balance: 0,
                point_rate: 0,
                available_loyality_points: 0,
              };
            }
          })
          .catch((err) => {
            console.log("Error:", err);
          })
          .finally(() => {
            // this.hideLoading();
          });
      }
    },
    applyLoyality(event, type = 4) {
      let cust_token = TokenService.getToken();
      if (!cust_token) {
        this.LoyalityDetails["ErrorMsg"] = "Please Add Customer";
        this.LoyalityDetails["SuccessMsg"] = "";
        return false;
      } else if (
        !this.LoyalityDetails["total_redeemable_points"] ||
        this.LoyalityDetails["total_redeemable_points"] == 0
      ) {
        this.LoyalityDetails["ErrorMsg"] = "Please Enter Points to Redeem";
        this.LoyalityDetails["SuccessMsg"] = "";
        return false;
      } else if (
        +parseFloat(this.LoyalityDetails["total_redeemable_points"]).toFixed(
          2
        ) >
        +parseFloat(this.LoyalityDetails["available_loyality_points"]).toFixed(
          2
        )
      ) {
        this.LoyalityDetails["ErrorMsg"] = `Maximum ${
          this.LoyalityDetails["available_loyality_points"]
        } points can be redeem!`;
        this.LoyalityDetails["SuccessMsg"] = "";
        return false;
      } else {
        this.showLoading();
        this.LoyalityDetails["ErrorMsg"] = "";
        this.LoyalityDetails["SuccessMsg"] = "";
        let payload = {
          customer_id: cust_token,
          fnb_total_amount: +parseFloat(this.fnb_gross_amount || 0).toFixed(2),
          ticket_total_amount: +parseFloat(
            this.ticket_gross_amount || 0
          ).toFixed(2),
          points: this.LoyalityDetails["total_redeemable_points"],
        };
        makeRequestBrij(
          `/api/cinema/upp_loyality/validate_cashback`,
          "POST",
          null,
          payload
        )
          .then((response) => {
            if (response && response.res.data.status) {
              console.log("response", response);
              const { points_obj } = response.res.data;
              this.hideLoading();
              this.showLoading();
              makeRequestBrij(`/api/external/save-voucher`, "POST", null, {
                reservation_id: this.ReserveID,
                voucher_code: null,
                loyalty_details: {
                  type: 4,
                  isLoyalityApplied: true,
                  loyality_amount: +parseFloat(points_obj["cashback"]).toFixed(
                    2
                  ),
                  bo_amount: +parseFloat(points_obj["bo_amount"]).toFixed(2),
                  fnb_amount: +parseFloat(points_obj["fnb_amount"]).toFixed(2),
                  point_rate: this.LoyalityDetails["point_rate"],
                  total_redeemable_points:
                    points_obj["total_redeemable_points"],
                  LoyaltyProgram: this.LoyalityDetails["LoyaltyProgram"],
                },
              })
                .then((result) => {
                  this.LoyalityDetails = {
                    ...this.LoyalityDetails,
                    loyality_amount: +parseFloat(
                      points_obj["cashback"]
                    ).toFixed(2),
                    bo_amount: +parseFloat(points_obj["bo_amount"]).toFixed(2),
                    fnb_amount: +parseFloat(points_obj["fnb_amount"]).toFixed(
                      2
                    ),
                    customer_id: cust_token,
                    total_redeemable_points:
                      points_obj["total_redeemable_points"],
                  };

                  this.LoyalityDetails["ErrorMsg"] = "";
                  this.LoyalityDetails["SuccessMsg"] =
                    "Your Ewallet Amount is Applied";
                  this.LoyalityDetails["isLoyalityApplied"] = true;
                  this.cardInputErrorMsg = "";
                  this.cardInputsuccessMsg = "";
                  this.promoCodeValue = "";
                  this.appliedBrijVoucher = null;
                  this.showDiscounttag = false;
                })
                .finally(() => {
                  this.hideLoading();
                });
            } else {
              this.hideLoading();
              this.LoyalityDetails = {
                ...this.LoyalityDetails,
                loyality_amount: 0,
                bo_amount: 0,
                fnb_amount: 0,
                customer_id: null,
                total_redeemable_points: null,
                ErrorMsg: response.res.data.message || "",
                SuccessMsg: "",
              };
            }
          })
          .catch((err) => {
            this.hideLoading();
            console.log("Error:", err);
          });
      }
    },
    removeEwallet(event, clearDb = true) {
      if (this.eWalletApplied) {
        this.eWalletAmount = "";
        this.eWalletApplied = false;
        this.ewalletSuccessMsg = "";
        if (clearDb) {
          this.showLoading();
          return makeRequestBrij(`/api/external/save-voucher`, "POST", null, {
            reservation_id: this.ReserveID,
            loyalty_details: {},
          })
            .then((result) => {
              this.hideLoading();
            })
            .catch((e) => {});
        }
      }
    },
    removeLoyality(event, clearDb = true) {
      if (this.LoyalityDetails["isLoyalityApplied"]) {
        this.LoyalityDetails = {
          ...this.LoyalityDetails,
          total_redeemable_points: null,
          bo_amount: 0,
          fnb_amount: 0,
          loyality_amount: 0,
          isLoyalityApplied: false,
          ErrorMsg: "",
          SuccessMsg: "",
        };
        if (clearDb) {
          this.showLoading();
          return makeRequestBrij(`/api/external/save-voucher`, "POST", null, {
            reservation_id: this.ReserveID,
            loyalty_details: {},
          })
            .then((result) => {
              this.hideLoading();
            })
            .catch((e) => {});
        }
      }
    },
    applyEwallet() {
      this.removeLoyality(null, false);
      let grandTotalAmount =
        +parseFloat(
          this.scheduleData.total_ticket_fnb -
            this.getSafe(
              () => this.appliedBrijVoucher.BoxOffice.TotalOfferPrice,
              0
            ) || "0"
        ).toFixed(2) || 0;
      this.ewalletSuccessMsg = "";
      if (!this.eWalletAmount || this.eWalletAmount < 0) {
        this.removeEwallet();
        this.ewalletErrorMessage = "Please Enter Valid Amount";
      } else if (this.eWalletAmount > grandTotalAmount) {
        this.removeEwallet();
        this.ewalletErrorMessage = `Your Total Amount  is Only ${grandTotalAmount} ${this
          .$store.getters.getGlobalCurrency.curr_code || "SAR"}`;
        this.ewalletSuccessMsg = "";
      } else if (this.eWalletAmount > this.ewalletBalance) {
        this.removeEwallet();
        this.ewalletErrorMessage = `Your Ewallet Balance is Only ${
          this.ewalletBalance
        } ${this.$store.getters.getGlobalCurrency.curr_code || "SAR"}`;
        this.ewalletSuccessMsg = "";
      } else {
        this.showLoading();
        makeRequestBrij(`/api/external/save-voucher`, "POST", null, {
          reservation_id: this.ReserveID,
          loyalty_details: {
            type: 2,
            eWalletAmount: this.eWalletAmount,
          },
        }).then((result) => {
          this.hideLoading();
          this.ewalletErrorMessage = "";
          this.ewalletSuccessMsg = "Your Ewallet Amount is Applied";
          this.eWalletApplied = true;
        });
      }
    },
    getActivePaymentModes() {
      makeRequestBrij(`/api/external/payment-modes/2`, "GET", null, null)
        .then((result) => {
          let { error, res = {} } = result;
          let { data = {} } = res;

          if (data.status && data.Records && data.Records.length > 0) {
            this.activePaymentModes = data.Records;
          } else {
            this.activePaymentModes = [];
          }

          console.log({
            getActivePaymentModes: data,
          });
        })
        .catch((e) => {
          this.activePaymentModes = [];

          console.log({
            getActivePaymentModes: e,
          });
        });
    },
    async getAllOfferDetailsBrij(offer) {
      let { os_id = undefined } = offer;

      let fallback = {
        status: true,
        message: "Records Successfully Fetched",
        error: null,
        Records: [],
        PromotionOfferCinemasRecords: [],
        PromotionOfferMoviesRecords: null,
        PromotionOfferDaysRecords: null,
        PromotionOfferScreensRecords: null,
        PromotionOfferSeatsTypeRecords: null,
        PromotionOfferTypesRecords: [],
        PromotionOfferBuyItems: [],
        PromotionOfferGetItems: [],
        OfferContent: [],
      };

      if (!os_id) return Promise.resolve(fallback);

      return makeRequestBrij(
        `/api/marketing/getactivepromotionsandoffers/${os_id}`,
        "GET",
        null,
        null
      )
        .then((response) => {
          const { error, res } = response;
          if (error) return fallback;

          return res.data.status ? res.data : fallback;
        })
        .catch((error) => {
          console.log(`error fetching offer details ${os_id}`, error);
          return fallback;
        });
    },

    getactivepromotionsandoffers() {
      this.showOfferLoading = true;

      let payload = {
        lang_id: this.getCurrentLang().brij_lang_id,
        limit: 1000,
        currentPage: 1,
        status: "Y",
        columnName: "os_id",
        orderBy: "desc",
      };

      console.log("this.reservationDetails", this.reservationDetails);
      console.log("this.selectedSeatsNew", this.selectedSeatsNew);
      let tt_id = null;
      let seat_type_id = null;

      this.selectedSeatsNew.map((x, index) => {
        if (x.tt_id) {
          tt_id = x.tt_id;
        }
        if (x.screen_seat_type_id) {
          seat_type_id = x.screen_seat_type_id;
        }
      });

      let show_date_time = moment(
        moment(
          this.reservationDetails.ss_actual_start_date,
          "YYYY-MM-DD"
        ).format("YYYY-MM-DD") +
          " " +
          moment(this.reservationDetails.ss_start_show_time, "HH:mm").format(
            "HH:mm"
          )
      ).valueOf();

      let newPayload = {
        cinema_id: this.reservationDetails.cinema_id || null,
        screen_id: this.reservationDetails.screen_id || null,
        seat_type_id: seat_type_id, // sst_id: null,
        movie_details_id: this.reservationDetails.md_id || null,
        show_date_time: this.reservationDetails.ss_start_date_time || null,
        show_actual_date_time: show_date_time || null,
        tt_id: tt_id,
      };

      payload.cinema_id = this.reservationDetails
        ? this.reservationDetails.cinema_id
        : undefined; // this.$store.getters.getSelectedBrijCinemas.cinema_id

      // this.showLoading()

      return makeRequestBrij(
        `/api/marketing/getAvailablePromotionsOffers`,
        "POST",
        null,
        newPayload
      )
        .then(({ error, res }) => {
          console.log("getActivePromotionsandOffers", { res });
          let { data } = res;

          let allOffers = res.data.status ? data.Records : [];
          let filteredOffers = allOffers || [];

          if (allOffers.length) {
            if (allOffers[0].hasOwnProperty("is_employee_offer")) {
              filteredOffers = allOffers.filter(
                (z) => z.is_employee_offer == "N"
              );
            }
          }

          return filteredOffers;
        })
        .then((offerListDetails) => {
          return Promise.all(
            offerListDetails.map((x) =>
              this.getAllOfferDetailsBrij(x).then((d) => ({
                ...x,
                offer: x,
                details: d,
              }))
            )
          );
        })
        .then((offerListDetails) => {
          // setting all offers as cinema offer
          offerListDetails.forEach((x) => {
            x.OfferID = 45; // mpm_d_id
          });

          console.log("offerListDetails", { offerListDetails });
          this.offerListDetails = offerListDetails;
        })
        .finally(() => {
          // this.hideLoading()
          this.showOfferLoading = false;
        });
    },

    getCinemaTranslatedName(cinema) {
      if (!cinema) return "";

      let name =
        this.getLangSpecificAttribute(
          cinema.translation_data || [],
          this.getCurrentLang().brij_lang_id,
          "cinema_name",
          "langaugeId"
        ) || cinema.cinema_name;

      return name;
    },
    getUserDetailsBrij: function(callback) {
      let token = TokenService.getToken();
      let payload = {};
      makeRequestBrij(
        `/api/external/get-customer-details/${token}`,
        "GET",
        null,
        null
      )
        .then((result) => {
          const { error, res } = result;
          if (!error && res.data.status) {
            // this.profileDetails = res.data.FirstName;
            this.profileDetails = res.data.EmpireData || {};

            this.userDetails.email = this.profileDetails.Email;
            this.userDetails.phoneNumber = this.profileDetails.Mobile;
            this.userDetails.CountryCode = this.profileDetails.CountryCode;
            this.userDetails.verfiymobile = this.profileDetails.verfiymobile;

            this.hideLoading();
          }
        })
        .catch((error) => {
          console.log("Error on vue front", error);
        });
    },

    callSeatReleased() {
      makeRequestBrij("/api/external/release-seat", "POST", null, {
        reservation_id: this.ReserveID,
      }).then((result2) => {});
    },
    showContent() {
      this.displayContent = !this.displayContent;
    },
    goBackExpired() {
      this.onClickOk();
    },
    onClickNo: function() {
      this.$refs.quitBooking.hide();
    },
    onClickOk: function() {
      this.$router.go(-1);
      this.$refs.errorModal.hide();
      this.$refs.quitBooking.hide();
      this.$refs.sessionExpired.hide();
    },
    goBackHistory() {
      this.onClickOk();
    },
    startTimer: function() {
      this.timerStartFunction = setInterval(() => {
        this.timer.seconds =
          this.timer.seconds > 0 ? parseFloat(this.timer.seconds) - 1 : 0;

        if (parseFloat(this.timer.seconds) < 10) {
          this.timer.seconds = "0" + this.timer.seconds;
        }

        if (parseFloat(this.timer.seconds) <= 0 && this.timer.minutes > 0) {
          this.timer.seconds = 59;
          this.timer.minutes =
            this.timer.minutes > 0 ? parseFloat(this.timer.minutes) - 1 : "00";
        }
        if (
          parseFloat(this.timer.minutes) == 0 &&
          parseFloat(this.timer.seconds) == 0
        ) {
          this.timer.seconds = "00";
          this.$refs["sessionExpired"].show();
          // this.$root.$emit("bv::show::modal", "sessionTimeOut");
          clearInterval(this.timerStartFunction);
          return false;
        } else {
        }
      }, 1000);
    },

    ChangeLoginStatus(isLogin) {
      if (isLogin) {
        this.$store.commit("storeLoginS");

        this.showLoginForm = false;
        this.$router.push({
          path: "/select-payment/" + this.ReserveID,
        });
      } else {
        console.log("token not found");
      }
    },
    linkMobile(userDetail) {
      this.showLoading();
      const payload = {
        change_number: this.getSafe(() => userDetail.phoneNumber || "", "")
          .trim()
          .split(" ")
          .join(""),
        resend_otp: "",
        verification_id: localStorage.getItem("verification_id"),
      };
      makeRequestBrij("/api/cinema/verify-user", "POST", null, payload)
        .then((result) => {
          const { error, res } = result;
          if (res.data.status) {
            this.$router.push({
              path: `/phoneotp?reserveId=${this.ReserveID}`,
            });
          } else {
            console.log('Error', res.data)
            this.$refs.updatedFailPopup.show();
            alert('Number already registered.');
          }
          this.hideLoading();
        })
        .catch((error) => {});
    },
    onFinalCheckOut() {
      this.isSeatReleased = false;
      localStorage.setItem("isChangeNumber", 0);
      ReactPixel.track("InitiateCheckout", {});
      ReactSnapPixel.track("InitiateCheckout", {});
      this.$ga.event({
        eventCategory: "begin_checkout",
      });
      tiktockCheckout();
      if (this.userLoginStatus == true) {
        if (!this.userDetails.verfiymobile) {
          localStorage.setItem("signinuserReserveId", this.ReserveID);

          window.localStorage.setItem("MIN", this.timer.minutes);
          window.localStorage.setItem("SEC", this.timer.seconds);
          localStorage.setItem("sheduleidphone", this.scheduleData.scheduleid);
          localStorage.setItem("checkPhone", 2);
          localStorage.setItem("reservedId", "");
          this.linkMobile(this.userDetails);
        } else {
          this.$router.push({
            path: "/select-payment/" + this.ReserveID,
          });
        }
      } else {
        this.showLoginForm = true;
      }
    },
    getGiftCardDetails() {
      // this.appliedBrijVoucher = null
      // this.cardInputErrorMsg = ''
      // this.errorMessage = ''
      // this.cardInputsuccessMsg = ''
      // this.appliedPromoName = ''
      // this.appliedOfferType = ''

      let grandTotalAmount =
        +parseFloat(
          this.scheduleData.total_ticket_fnb -
            this.getSafe(
              () => this.appliedBrijVoucher.BoxOffice.TotalOfferPrice,
              0
            ) || "0"
        ).toFixed(2) || 0;

      this.showRedeemAmountTab = false;
      this.giftCardDetails = null;
      this.giftCardErrorMsg = "";
      this.giftCardInputsuccessMsg = "";

      if (!this.giftCardNumber) {
        this.giftCardErrorMsg = "Please Enter Gift Card Number";

        return false;
      }

      this.showLoading();
      makeRequestBrij(
        `/api/pos/merit_gc/get_balance/${this.giftCardNumber || ""}`,
        "GET",
        null,
        null
      )
        .then((result) => {
          const { error, res } = result;

          if (!res.data || !res.data.status) {
            this.giftCardDetails = null;
            console.log({
              "res.data.message": res.data.message,
            });
            this.giftCardErrorMsg = res.data.message;
          } else {
            if (
              res.data.hasOwnProperty("balance") &&
              +parseFloat(res.data.balance) < grandTotalAmount
            ) {
              this.giftCardErrorMsg = `Low Balance. ${
                this.allLanguageData.YourCurrentBalanceIs
              }: ${this.getSafe(
                () => res.data.cardDetails.giftcard_currency,
                "SAR"
              )} ${res.data.balance}`;
              this.giftCardDetails = null;
            } else {
              this.giftCardRedeemValue = grandTotalAmount;
              this.giftCardDetails = res.data;
            }
          }

          console.log({
            res,
            error,
          });
        })
        .catch((error) => {
          this.giftCardDetails = null;

          console.log({
            error,
          });
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    resetGiftCardDetails() {
      this.showRedeemAmountTab = false;
      this.giftCardRedeemValue = 0;
      this.giftCardDetails = null;
      this.giftCardErrorMsg = "";
      this.giftCardInputsuccessMsg = "";
      this.giftCardNumber = "";

      return makeRequestBrij(`/api/external/save-voucher`, "POST", null, {
        reservation_id: this.ReserveID,
        loyalty_details: {},
      })
        .then((result) => {})
        .catch((e) => {});
    },
    redeemGiftCard() {
      // clear existing offer/voucher
      return Promise.resolve()
        .then(() => {
          return makeRequestBrij(`/api/external/save-voucher`, "POST", null, {
            reservation_id: this.ReserveID,
          })
            .then((result) => ({}))
            .catch((e) => ({}));
        })
        .then(() => {
          this.cardInputErrorMsg = "";
          this.cardInputsuccessMsg = "";
          this.promoCodeValue = "";
          this.appliedBrijVoucher = null;
          this.showDiscounttag = false;
        })
        .finally(() => {
          // then apply gift card
          this.showRedeemAmountTab = false;
          this.giftCardErrorMsg = "";
          this.giftCardInputsuccessMsg = "";

          let currentBalance =
            this.getSafe(
              () => parseFloat(this.giftCardDetails.balance),
              parseFloat(0)
            ) || parseFloat(0);
          let redeemValue =
            this.getSafe(
              () => parseFloat(this.giftCardRedeemValue),
              parseFloat(0)
            ) || parseFloat(0);

          let grandTotal =
            +parseFloat(
              this.scheduleData.total_ticket_fnb -
                this.getSafe(
                  () => this.appliedBrijVoucher.BoxOffice.TotalOfferPrice,
                  0
                ) || "0"
            ).toFixed(2) || 0;

          console.log({
            giftCardRedeemValue: this.giftCardRedeemValue,
            giftCardDetails: this.giftCardDetails,
            currentBalance,
            redeemValue,
            grandTotal,
          });

          if (grandTotal <= 0) {
            return;
          }

          if (currentBalance <= 0) {
            this.giftCardErrorMsg = "Low Balance";
            return;
          }

          if (redeemValue <= 0) {
            this.giftCardErrorMsg = "Redeem Value should be greater than 0";
            return;
          }

          if (redeemValue > grandTotal) {
            this.giftCardErrorMsg =
              "Redeem Value should not be greater than grand total";
            return;
          }

          console.log({
            currentBalance,
            redeemValue,
            grandTotal,
          });

          return makeRequestBrij(`/api/external/save-voucher`, "POST", null, {
            reservation_id: this.ReserveID,
            loyalty_details: {
              type: 1,
              merit_card_number: this.giftCardNumber || 0,
              redeem_value: this.giftCardRedeemValue || 0,
            },
          })
            .then((result) => {
              this.showRedeemAmountTab = true;
              this.appliedPromoName = this.allLanguageData.GiftCard;
              this.showDiscounttag = true;
            })
            .catch((e) => {
              // this.showRedeemAmountTab = false
              // this.giftCardErrorMsg = ''
              // this.giftCardInputsuccessMsg = ''
              // this.giftCardRedeemValue = 0
            })
            .finally(() => {
              this.hideLoading();
            });
        });
    },
    reserveSelectedVoucher(data, id, indx) {
      this.appliedBrijVoucher = null;
      this.cardInputErrorMsg = "";
      this.errorMessage = "";
      this.cardInputsuccessMsg = "";
      this.appliedPromoName = "";
      this.appliedOfferType = "";

      this.Offerindex = indx;
      let payload = {};
      if (data) {
        // this.appliedPromoName = data.Name
        // this.selectedPromotionID = data.ShowbizzVoucherID
        // payload = {
        //   PromotionName: data.Name,
        //   ReserveID: this.ReserveID,
        //   PromotionID: data.ShowbizzVoucherID,
        //   isPromoCode: 0,
        //   TransactionType: 'Normal',
        // }
      } else {
        this.appliedPromoName = this.promoCodeValue;
        this.appliedOfferType = "4";
        payload = {
          ReserveID: this.ReserveID,
          isPromoCode: 1,
          LanguageID: 2,
          CountryID: 230,
          TransactionType: "Normal",
          promoCode: this.promoCodeValue,
          CouponType: 4,
          reservation_id: this.ReserveID,
        };
      }

      let voucher = {
        reservation_id: this.ReserveID,
        cinema_id: this.reservationDetails.cinema_id,
        cinema_name: this.reservationDetails.cine_name,
        isTicket: true,
        md_id: this.reservationDetails.md_id,
        net_amount: this.reservationDetails.net_amount,
        total_amount: this.reservationDetails.amount, // + getRateCardAddonsTotal(add_ons_array),
        total_ticket: this.reservationDetails.selectedSeats.length,
        voucher_title: this.promoCodeValue,
        voucher_code: this.promoCodeValue,
      };

      if (
        this.reservationDetails.fnb_data &&
        this.reservationDetails.fnb_data.selected_fnb_items &&
        this.reservationDetails.fnb_data.selected_fnb_items.length
      ) {
        voucher.isComboApplied = true;

        voucher.fnb_total_amount = this.reservationDetails.fnb_data.fnb_price.total_price;

        voucher.fnb_total_item = this.reservationDetails.fnb_data.selected_fnb_items.length;

        voucher.fnb_net_amount =
          this.reservationDetails.fnb_data.fnb_price.total_price -
          this.reservationDetails.fnb_data.fnb_price.total_tax;
      }

      this.showLoading();
      console.log({ payload, voucher });

      makeRequestBrij(`/api/external/v2/verify-voucher`, "POST", null, voucher)
        .then((result) => {
          const { error, res } = result;
          console.log({ data: res.data });
          if (res.data.status) {
            // this.getReserveInfo(this.ReserveID, '1')
            this.appliedBrijVoucher = res.data;
            this.showDiscounttag = true;
            this.cardInputsuccessMsg = res.data.message;
            this.removeEwallet();
            this.removeLoyality(null, false);
            return voucher.voucher_code;
          } else {
            this.appliedBrijVoucher = null;
            this.cardInputErrorMsg = res.data.message;
            this.showDiscounttag = false;
            return false;
          }
        })
        .then((result) => {
          if (result) {
            return makeRequestBrij(`/api/external/save-voucher`, "POST", null, {
              reservation_id: this.ReserveID,
              voucher_code: result,
            })
              .then((result) => ({}))
              .catch((e) => ({}));
          } else {
            return Promise.resolve();
          }
        })
        .then((result) => {
          return this.resetGiftCardDetails();
        })
        .catch((error) => {
          this.appliedBrijVoucher = null;
          this.showDiscounttag = false;
          console.log("error", error);
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    reserveSelectedOfferPromotion(data, id, indx) {
      console.log({ reserveSelectedOfferPromotion: data });

      this.appliedBrijVoucher = null;
      this.cardInputErrorMsg = "";
      this.errorMessage = "";
      this.cardInputsuccessMsg = "";
      this.appliedPromoName = "";
      this.appliedOfferType = "";

      this.Offerindex = indx;
      let payload = {};

      this.appliedPromoName = this.getSafe(() => data.offer_title, "Offer");
      // this.selectedPromotionID = data.ShowbizzVoucherID
      // payload = {
      //   PromotionName: data.Name,
      //   ReserveID: this.ReserveID,
      //   PromotionID: data.ShowbizzVoucherID,
      //   isPromoCode: 0,
      //   TransactionType: 'Normal',
      // }
      console.log(data.details);
      let cust_token = TokenService.getToken();
      let offer = {
        cinema_id: this.reservationDetails.cinema_id,
        cinema_name: this.reservationDetails.cine_name,
        isTicket: true,
        reservation_id: this.ReserveID,
        customer_id: cust_token || "",
        md_id: this.reservationDetails.md_id,
        net_amount: this.reservationDetails.net_amount,
        total_amount: this.scheduleData.amount, // + getRateCardAddonsTotal(add_ons_array),
        total_ticket: this.reservationDetails.selectedSeats.length,
        fnb_items: [],
        // voucher_title: this.promoCodeValue,
        // voucher_code: this.promoCodeValue,
        oc_id: this.getSafe(
          () => data.details.PromotionOfferTypesRecords[0].oc_id
        ),
      };

      if (
        this.reservationDetails.fnb_data &&
        this.reservationDetails.fnb_data.selected_fnb_items &&
        this.reservationDetails.fnb_data.selected_fnb_items.length
      ) {
        offer.isComboApplied = true;
        offer.fnb_items =
          this.reservationDetails.fnb_data.selected_fnb_items || [];
        offer.fnb_total_amount = this.reservationDetails.fnb_data.fnb_price.total_price;

        offer.fnb_total_item = this.reservationDetails.fnb_data.selected_fnb_items.length;

        offer.fnb_net_amount =
          this.reservationDetails.fnb_data.fnb_price.total_price -
          this.reservationDetails.fnb_data.fnb_price.total_tax;
      }

      this.showLoading();
      console.log({ payload, offer });

      makeRequestBrij(`/api/marketing/v2/verifyPromotion`, "POST", null, offer)
        .then((result) => {
          const { error, res } = result;
          console.log({ data: res.data });
          if (res.data.status) {
            // this.getReserveInfo(this.ReserveID, '1')
            this.appliedBrijVoucher = res.data;
            this.showDiscounttag = true;
            this.cardInputsuccessMsg = res.data.message;
            this.removeEwallet();
            this.removeLoyality(null, false);
          } else {
            this.appliedBrijVoucher = null;
            this.cardInputErrorMsg = res.data.message;
            this.showDiscounttag = false;
          }
          return res.data;
        })
        .then(async (response) => {
          let updateObj = {
            reservation_id: this.ReserveID,
          };
          if (
            response.status &&
            response.Records &&
            response.Records.length > 0
          ) {
            let OfferDetails = response.Records[0];
            if (OfferDetails && [3, 9].includes(OfferDetails.offer_type_id)) {
              this.calculateOfferDetails(OfferDetails);
            }
            updateObj["oc_id"] = OfferDetails.oc_id;
            updateObj["offer_promotion_payload"] = JSON.stringify(offer);
            return updateObj;
          } else {
            return updateObj;
          }
        })
        .then((responseObj) => {
          // clear voucher if any
          return makeRequestBrij(
            `/api/external/save-voucher`,
            "POST",
            null,
            responseObj
          )
            .then((result) => ({}))
            .catch((e) => ({}));
        })
        .then((result) => {
          return this.resetGiftCardDetails();
        })
        .catch((error) => {
          this.appliedBrijVoucher = null;
          this.showDiscounttag = false;
          console.log("error", error);
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    removeAddedOffer() {
      let payload = {
        ReserveID: this.ReserveID,
        PromotionID: this.selectedPromotionID,
        TransactionType: "Normal",
      };
      this.showLoading();

      Promise.resolve(this.promoCodeValue)
        .then((result) => {
          return makeRequestBrij(`/api/external/save-voucher`, "POST", null, {
            reservation_id: this.ReserveID,
            voucher_code: null,
          })
            .then((result) => ({}))
            .catch((e) => ({}));
        })
        .then((result) => {
          return this.resetGiftCardDetails();
        })
        .then(() => {
          this.cardInputErrorMsg = "";
          this.cardInputsuccessMsg = "";
          this.promoCodeValue = "";
          this.appliedBrijVoucher = null;
          this.showDiscounttag = false;
          this.hideLoading();
        });
    },
    showOffersDetails(data) {
      // this.showOfferLoading = true;
      // this.hideLoading();
      // this.showLoading();
      // this.offerListDetails = [];
      if (data && data.OfferID) {
        this.headerTitleId = data.OfferID;
      }

      let payload = {
        OfferID: this.headerTitleId,
        ReserveID: this.ReserveID,
      };

      // makeRequest("/OfferMaster", "POST", null, payload)
      //   .then(result => {
      //     const { error, res } = result;
      //     const { data } = res.data;
      //     this.showOfferLoading = false;
      //     if (!error) {
      //       console.log(res.data);
      //
      //       if (
      //         res.data.hasOwnProperty("OfferList") &&
      //         res.data.OfferList.length > 0
      //       ) {
      //         this.offerListDetails = res.data.OfferList;
      //       }
      //     } else {
      //       console.log("object");
      //     }
      //     this.showOfferLoading = false;
      //     this.hideLoading();
      //   })
      //   .catch(error => {
      //     this.showOfferLoading = false;
      //     this.hideLoading();
      //
      //     console.log("error", error);
      //   });
    },
    goBack() {
      this.$refs["quitBooking"].show();

      // this.$router.go(-1);
    },
    getReserveInfo(ReserveID, reload = true) {
      this.hideLoading();
      let payload = {};
      this.showLoading();
      makeRequestBrij(
        `/api/external/reservation-detail/${ReserveID}`,
        "GET",
        null,
        null
      )
        .then((result) => {
          const { error, res } = result;
          const { data } = res.data;

          if (!error) {
            if (res.data && res.data.status) {
              let schedule_detail = res.data.Records[0];
              this.reservationDetails = res.data.Records[0];
              if (schedule_detail.add_ons_array.length) {
                this.add_ons_array =
                  schedule_detail.add_ons_array[0].gross_amount_addons;

                this.add_ons_array_on_final_price = schedule_detail
                  .add_ons_array[0].gross_amount_addons_on_ticket
                  ? schedule_detail.add_ons_array[0]
                      .gross_amount_addons_on_ticket
                  : [];
                this.add_ons_total =
                  schedule_detail.add_ons_array[0].BoxOfficeFinal.TotalAddons;
                // quantity //addons_name //final_price
              }

              this.scheduleData.fnb_total = 0;
              if (
                schedule_detail.hasOwnProperty("fnb_data") &&
                schedule_detail.fnb_data &&
                schedule_detail.fnb_data.hasOwnProperty("selected_fnb_items") &&
                schedule_detail.fnb_data.selected_fnb_items.length > 0
              ) {
                console.log(
                  schedule_detail.fnb_data.selected_fnb_items,
                  "FNBBB"
                );
                this.fnbItemDataArry =
                  schedule_detail.fnb_data.selected_fnb_items;

                this.fnbItemDataArry.map((z) => {
                  z["qty"] = z.Quantity;
                  z["Qty"] = z.Quantity;
                  z["title"] = z.item_name;
                  this.scheduleData.fnb_total = +parseFloat(
                    this.scheduleData.fnb_total + z.fp_total_amount * z.Quantity
                  ).toFixed(2);
                });
              } else {
                console.log("res.datares.datares.datares.datares.data");
              }

              this.scheduleData.movie_name =
                this.getLangSpecificAttribute(
                  schedule_detail.altMovieContent,
                  this.getCurrentLang().brij_lang_id,
                  "mc_title"
                ) ||
                schedule_detail.movie_title ||
                schedule_detail.original_title_of_movie;
              this.scheduleData.ScreenName = schedule_detail.screen_name;
              this.scheduleData.exp = schedule_detail.mf_name;
              this.scheduleData.cinemaname =
                this.getCinemaTranslatedName(schedule_detail) ||
                schedule_detail.cine_name;
              this.scheduleData.time = moment(
                schedule_detail.ss_start_show_time,
                "HH:mm"
              )
                .locale(this.getCurrentLang().iso_2 || "en")
                .format("hh:mm A");
              this.scheduleData.date = moment(
                schedule_detail.ss_actual_start_date
              )
                .locale(this.getCurrentLang().iso_2 || "en")
                .format("ddd, DD MMM YYYY");
              this.scheduleData.totalseatcount =
                schedule_detail.selectedSeats.length;
              this.scheduleData.currency =
                this.$store.getters.getGlobalCurrency.curr_code || "Sar";
              this.scheduleData.amount = +parseFloat(
                schedule_detail.amount
              ).toFixed(2);
              this.scheduleData.total_internet_handling_amt = +parseFloat(
                schedule_detail.internet_handling_fee
              ).toFixed(2);

              this.internet_handling_fees =
                res.data.is_internet_handling_fee_applied == "Y" &&
                this.scheduleData.total_internet_handling_amt > 0;

              if (
                schedule_detail.hasOwnProperty("selectedSeats") &&
                schedule_detail.selectedSeats.length > 0
              ) {
                this.selectedSeatsNew = schedule_detail.selectedSeats;
                let seatName = [];
                this.selectedSeatsNew.map((x, index) => {
                  let obj = {
                    sst_seat_type: x.sst_seat_type,
                    screen_seat_type_id: x.screen_seat_type_id,
                    seatName:
                      x.seat_reserve_type_id != "3" ? [x.sl_seat_name] : [],
                    wheelChair:
                      x.seat_reserve_type_id == "3" ? [x.sl_seat_name] : [],
                  };
                  let findIndex = seatName.findIndex((z) => {
                    return z.screen_seat_type_id == x.screen_seat_type_id;
                  });
                  if (findIndex >= 0) {
                    if (x.seat_reserve_type_id == "3") {
                      seatName[findIndex]["wheelChair"].push(x.sl_seat_name);
                    } else {
                      seatName[findIndex]["seatName"].push(x.sl_seat_name);
                    }
                  } else {
                    seatName.push(obj);
                  }
                });

                console.log(seatName, "selectedSeatsNew");
                this.normal_seats = seatName;

                if (schedule_detail.amount) {
                  this.totalAmount = schedule_detail.amount.toFixed(2);
                }
                this.showTimer = true;
                this.timer.minutes = schedule_detail.timer_minutes;
                this.timer.seconds = schedule_detail.timer_second;
                this.startTimer();
              }

              let amount_addons = 0;

              if (this.add_ons_array_on_final_price.length > 0) {
                this.add_ons_array_on_final_price.map((z) => {
                  amount_addons += z.final_price;
                });

                this.scheduleData.amount =
                  this.scheduleData.amount + amount_addons;

                this.add_ons_total = this.add_ons_total - amount_addons;
              }

              this.scheduleData.total_ticket_fnb = +parseFloat(
                this.scheduleData.fnb_total +
                  this.scheduleData.amount +
                  schedule_detail.internet_handling_fee +
                  this.add_ons_total
              ).toFixed(2);

              this.hideLoading();
              setTimeout((z) => {
                if (this.ewalletBalance > 0) {
                  if (this.scheduleData.total_ticket_fnb) {
                    this.eWalletAmount = this.scheduleData.total_ticket_fnb;
                  }
                  if (
                    this.ewalletBalance < this.scheduleData.total_ticket_fnb
                  ) {
                    this.eWalletAmount = this.ewalletBalance;
                  }
                }
              }, 500);
              if (reload) {
                this.getfnbDataBrij();
              }
            } else {
              setTimeout(() => {
                this.$refs["errorModal"].show();
                this.errorMessage = res.data.message;
                this.hideLoading();
              });
            }
          } else {
            console.log("object");
          }
        })
        .then(() => {
          if (reload) {
            return makeRequestBrij(`/api/external/save-voucher`, "POST", null, {
              reservation_id: ReserveID,
            })
              .then((result) => ({}))
              .catch((e) => ({}));
          } else {
            return true;
          }
        })
        .then(() => {
          if (reload) {
            this.getactivepromotionsandoffers();
          }
        })
        .catch((error) => {
          this.hideLoading();
          console.log("error", error);
        });
    },
    getReserveInfoOld(ReserveID, id) {
      let payload = {
        ReserveID: ReserveID,
        CategoryID: "1",
        TransactionType: "Normal",
      };
      this.showLoading();
      makeRequestBrij(
        `/api/external/reservation-detail/${ReserveID}`,
        "GET",
        null,
        null
      )
        .then((result) => {
          const { error, res } = result;
          const { data } = res.data;
          if (!error) {
            if (res.data) {
              if (
                res.data.hasOwnProperty("fnb_data") &&
                res.data.fnb_data.hasOwnProperty("selected_fnb_items") &&
                res.data.fnb_data.selected_fnb_items > 0
              ) {
                console.log(res.data);
                this.fnbItemDataArry = res.data.fnb_data.selected_fnb_items;
                this.fnbItemDataArry.map((z) => {
                  z["qty"] = z.Quantity;
                  z["Qty"] = z.Quantity;
                  z["title"] = z.item_name;
                });
              }

              let obj = {
                reserveData: res.data,
              };

              Object.keys(this.scheduleData).map((x) => {
                this.scheduleData[x] = obj.reserveData[x] || "";
              });
              if (
                res.data.hasOwnProperty("seats") &&
                res.data.seats.length > 0
              ) {
                this.selectedSeats = res.data.seats[0].cat_seats;
                if (
                  res.data.seats[0].normal_seats &&
                  res.data.seats[0].normal_seats.length > 0
                ) {
                  this.normal_seats = res.data.seats[0].normal_seats.join(",");
                  this.SeatLable = res.data.seats[0].SeatLable;
                }
                if (
                  res.data.seats[0].normal_seats &&
                  res.data.seats[0].wc_seats.length > 0
                ) {
                  this.wc_seats = res.data.seats[0].wc_seats.join(",");
                }
              }
              if (id == "0") {
                if (
                  window.localStorage.getItem("MIN") &&
                  window.localStorage.getItem("SEC")
                ) {
                  this.timer.minutes = window.localStorage.getItem("MIN");
                  this.timer.seconds = window.localStorage.getItem("SEC");
                  this.startTimer();
                } else if (window.localStorage.getItem("SKPFNB") == "Y") {
                  this.startTimer();
                } else {
                  this.$router.push({
                    path: "/seatLayout/" + this.scheduleData.scheduleid,
                  });
                }
              }
            }
          } else {
            console.log("object");
          }

          this.showTimer = true;
          window.localStorage.setItem("MIN", "");
          window.localStorage.setItem("SEC", "");
          window.localStorage.setItem("SKPFNB", "");

          this.hideLoading();
        })
        .catch((error) => {
          this.showTimer = true;
          window.localStorage.setItem("MIN", "");
          window.localStorage.setItem("SEC", "");
          window.localStorage.setItem("SKPFNB", "");
          this.hideLoading();

          console.log("error", error);
        });
    },
    getAllOffers() {
      // this.showLoading();
      this.offerTitle = [];
      makeRequest("/OfferMaster", "POST", null, null)
        .then((result) => {
          const { error, res } = result;
          const { data } = res.data;
          if (!error) {
            if (
              res.data.hasOwnProperty("OfferMaster") &&
              res.data.OfferMaster.length > 0
            ) {
              console.log(res.data.OfferMaster);
              res.data.OfferMaster.map((x) => {
                if (
                  x.OfferID != "2" &&
                  x.OfferID != "4" &&
                  x.OfferID != "7" &&
                  x.OfferID != "8"
                ) {
                  this.offerTitle.push(x);
                }
              });
              this.showOffersDetails();
              // this.getOfferDetails();
            }
          } else {
            console.log("object");
          }
          this.hideLoading();
        })
        .catch((error) => {
          this.hideLoading();

          console.log("error", error);
        });
    },
    getUserDetails: function() {
      let token = TokenService.getToken();
      let payload = {};
      makeRequest("/ProfileDataNew", "POST", token, payload)
        .then((result) => {
          const { error, res } = result;
          this.userDetails.email = res.data.Email;
          this.userDetails.phoneNumber = res.data.Mobile;
          this.userDetails.CountryCode = res.data.CountryCode;
          this.userDetails.verfiymobile = res.data.verfiymobile;

          this.hideLoading();
        })
        .catch((error) => {
          console.log("Error on vue front", error);
        });
      setTimeout(() => {
        this.hideLoading();
      }, 5000);
    },
    getfnbDataBrij() {
      this.showLoading();
      let payloadNew = {
        category: null,
        aggregator_cinema_id: this.reservationDetails.cinema_id,
        cinema_id: this.reservationDetails.cinema_id,
        isCombo: false,
        isEgg: "",
        isVeg: "",
        search: "",
        subCategory: null,
        reservation_id: this.ReserveID || null,
      };
      makeRequestBrij(`/api/external/fnb-items`, "POST", null, payloadNew).then(
        (responseFnb) => {
          this.hideLoading();
          if (responseFnb.res.data.Records.Records.length > 0) {
            let dataFnb = responseFnb.res.data.Records.Records;
            let FNBItem = [];
            this.fnbItems = responseFnb.res.data.Records.Records || [];
            dataFnb.map((z) => {
              let check = FNBItem.findIndex((_fnb) => {
                return _fnb.Id == z.cat_id; // z.fc_id
              });
              if (check >= 0) {
                FNBItem[check]["itemcount"] = FNBItem[check]["itemcount"] + 1;
                let obj = {
                  Category: z.cat_id, // z.fc_id,
                  ItemName: z.item_name,
                  Amount: z.fp_total_amount,
                  Currency:
                    this.$store.getters.getGlobalCurrency.curr_code || "Sar",
                  Description: z.item_description,
                  ThumbnailImage: z.item_image_url,
                  Qty: 0,
                  Id: z.item_id,
                  TotalAmount: z.fp_total_amount,
                  FnbDetail: { ...z },
                  order: z.p_fc_order || z.fc_order || 1999,
                };

                FNBItem[check]["items"].push(obj);
              } else {
                let obj = {
                  Id: z.cat_id, // z.fc_id,
                  Title: z.fc_category,
                  items: [
                    {
                      Category: z.cat_id, // z.fc_id,
                      ItemName: z.item_name,
                      Amount: z.fp_total_amount,
                      Currency:
                        this.$store.getters.getGlobalCurrency.curr_code ||
                        "Sar",
                      Description: z.item_description,
                      ThumbnailImage: z.item_image_url,
                      Qty: 0,
                      Id: z.item_id,
                      TotalAmount: z.fp_total_amount,
                      FnbDetail: { ...z },
                    },
                  ],
                  itemcount: 1,
                };
                FNBItem.push(obj);
              }
            });

            // sorting sub items
            FNBItem.forEach((f) => {
              f.items = f.items
                .map((z) => z)
                .sort((a, b) => {
                  let comparison = a.Amount - b.Amount;

                  if (comparison === 0) {
                    comparison =
                      b.FnbDetail.fc_parent_id - a.FnbDetail.fc_parent_id;
                  }
                  if (comparison === 0) {
                    comparison = b.FnbDetail.fc_id - a.FnbDetail.fc_id;
                  }
                  if (comparison === 0) {
                    comparison = b.FnbDetail.cat_id - a.FnbDetail.cat_id;
                  }

                  return comparison;
                });
            });

            // sorting fnb items
            FNBItem = FNBItem.sort((a, b) => {
              let comparison = a.order - b.order;
              if (comparison === 0) comparison = a.Id - b.Id;

              return comparison;
            });

            // setting index
            FNBItem.forEach((fnb, fnb_index) => {
              fnb.fnbItemDataIndex = fnb_index;
              fnb.items.forEach((item, item_index) => {
                item.fnbItemDataIndex = fnb_index;
                item.fnbItemDataItemsIndex = item_index;
              });
            });

            // making groups of categories
            FNBItem.forEach((f) => {
              let grp = this.groupByToMap(f.items, (x) =>
                JSON.stringify({
                  fc_id: x.FnbDetail.fc_id,
                  fc_parent_id: x.FnbDetail.fc_parent_id,
                  fc_category: x.FnbDetail.fc_category,
                  p_fc_category: x.FnbDetail.p_fc_category,
                })
              );
              let grouped = [];
              for (const [key, value] of grp) {
                let category = JSON.parse(String(key));
                let items = [...value];
                let grpItems = { ...category, items };
                grouped.push(grpItems);
              }
              grouped.forEach((item, item_index) => {
                item.groupedItemsIndex = item_index;
              });
              f.groupedItems = grouped;
            });

            this.fnbItemData = FNBItem;
            this.fnbItemDataTemp = FNBItem;

            console.log("FNBItem", FNBItem);
          }
        }
      );
    },
    calculateOfferDetails(offer) {
      if (offer.offer_type_id == 9) {
        let TotalSeats = this.reservationDetails.selectedSeats.length;
        let FinalFNBArray = [];
        let selectedFnbItems = [];
        let totalTicketOffer = 0;

        totalTicketOffer = parseInt(
          Math.floor(TotalSeats / parseInt(offer.oc_buy_no_of_ticket))
        );

        if (
          offer.oc_max_no_of_ticket_per_transaction &&
          totalTicketOffer > offer.oc_max_no_of_ticket_per_transaction &&
          offer.oc_max_no_of_ticket_per_transaction > 0
        ) {
          totalTicketOffer = offer.oc_max_no_of_ticket_per_transaction;
        }

        if (TotalSeats >= offer.oc_buy_no_of_ticket) {
          if (offer.oc_is_combo_with_fnb == "Y") {
            let fnbItemsArray = offer.fnb_group_data || [];

            for (let i = 0; i < fnbItemsArray.length; i++) {
              let itemObj = fnbItemsArray[i];

              let offerFnbItem = this.fnbItems.filter(
                (x) =>
                  x.item_code == itemObj.oc_buy_item_code ||
                  itemObj.oc_buy_item_id == x.item_id
              );
              if (offerFnbItem.length > 0) {
                if (
                  this.reservationDetails.fnb_data &&
                  this.reservationDetails.fnb_data.hasOwnProperty(
                    "selected_fnb_items"
                  ) &&
                  this.reservationDetails.fnb_data.selected_fnb_items &&
                  this.reservationDetails.fnb_data.selected_fnb_items.length > 0
                ) {
                  selectedFnbItems = this.reservationDetails.fnb_data
                    .selected_fnb_items;
                }

                let itemQty =
                  parseInt(itemObj.oc_buy_no_of_item || 1) *
                  parseInt(totalTicketOffer || 1);
                let checkAlreadyAddedItem = selectedFnbItems.findIndex(
                  (x) => x.item_code == itemObj.oc_buy_item_code
                );
                if (checkAlreadyAddedItem > -1) {
                  if (selectedFnbItems[checkAlreadyAddedItem].Qty == itemQty) {
                    // DO NOTHING
                  } else {
                    selectedFnbItems[checkAlreadyAddedItem].Qty += itemQty;
                  }
                } else {
                  let fnbObj = {
                    ...offerFnbItem[0],
                    Qty: itemQty,
                  };
                  selectedFnbItems.push(fnbObj);
                }
              } else {
                this.removeAddedOffer();
              }
            }
            if (selectedFnbItems.length > 0) {
              selectedFnbItems.forEach((x) => {
                let TotalPrice =
                  +parseFloat(x.fp_total_amount).toFixed(4) * x.Qty;
                let TotalTax =
                  +parseFloat(x.fp_total_amount - x.fp_amount).toFixed(4) *
                  x.Qty;

                this.FNbPrice["total_price"] = +parseFloat(
                  this.FNbPrice["total_price"] + TotalPrice
                ).toFixed(4);
                this.FNbPrice["total_tax"] = +parseFloat(
                  this.FNbPrice["total_tax"] + TotalTax
                ).toFixed(4);
                let obj = {
                  ...x,
                  Quantity: x.Qty,
                  quantity: x.Qty,
                  total_price: TotalPrice,
                  total_tax: TotalTax,
                };
                FinalFNBArray.push(obj);
                this.totalAmount = +parseFloat(
                  parseFloat(this.totalAmount) + parseFloat(TotalPrice)
                ).toFixed(4);
              });

              this.onUpdateFnbCartItems(FinalFNBArray);
            }
          } else {
          }
        } else {
          this.removeAddedOffer();
        }
      } else if (offer.offer_type_id == 3) {
        let selectedFnbItems = [];
        if (
          this.reservationDetails.fnb_data &&
          this.reservationDetails.fnb_data.hasOwnProperty(
            "selected_fnb_items"
          ) &&
          this.reservationDetails.fnb_data.selected_fnb_items &&
          this.reservationDetails.fnb_data.selected_fnb_items.length > 0
        ) {
          selectedFnbItems = this.reservationDetails.fnb_data
            .selected_fnb_items;
        }
        if (
          offer.oc_is_combo == "Y" &&
          offer.oc_is_combo_free == "Y" &&
          offer.oc_is_combo_with_fnb == "N"
        ) {
          let TotalSeats = this.reservationDetails.selectedSeats.length;
          if (TotalSeats >= offer.oc_buy_no_of_ticket) {
            let offerFnbItem = this.fnbItems.filter(
              (x) => x.item_code == offer.oc_get_item_code
            );

            let getItemCount = 0;
            selectedFnbItems.forEach((x) => {
              if (
                x.item_id == offer.oc_get_item_id ||
                x.item_code == offer.oc_get_item_code
              ) {
                getItemCount += x.quantity;
              }
            });
            let totalFreeItemQty = 0;
            if (
              offer.oc_buy_no_of_ticket == offer.oc_get_item_count &&
              offer.oc_buy_item_count > 1
            ) {
              totalFreeItemQty = parseInt(
                Math.floor(
                  TotalSeats /
                    parseInt(
                      offer.oc_buy_no_of_ticket + offer.oc_get_item_count
                    )
                ) * offer.oc_get_item_count
              );
            } else {
              totalFreeItemQty = parseInt(
                Math.floor(TotalSeats / parseInt(offer.oc_buy_no_of_ticket)) *
                  offer.oc_get_item_count
              );
            }

            if (offerFnbItem.length > 0) {
              let itemQty = totalFreeItemQty || 1;
              let checkAlreadyAddedItem = selectedFnbItems.findIndex(
                (x) => x.item_code == offer.oc_get_item_code
              );
              if (checkAlreadyAddedItem > -1) {
                if (selectedFnbItems[checkAlreadyAddedItem].Qty == itemQty) {
                  // DO NOTHING
                } else {
                  selectedFnbItems[checkAlreadyAddedItem].Qty += itemQty;
                }
              } else {
                let fnbObj = {
                  ...offerFnbItem[0],
                  Qty: itemQty,
                };
                selectedFnbItems.push(fnbObj);
              }
              this.finalCalculationFnb(selectedFnbItems);
            } else {
              this.removeAddedOffer();
            }
          } else {
            this.removeAddedOffer();
          }
        } else if (
          offer.oc_is_combo == "Y" &&
          offer.oc_is_combo_free == "N" &&
          offer.oc_is_combo_with_fnb == "N"
        ) {
          let TotalSeats = this.reservationDetails.selectedSeats.length;
          if (TotalSeats >= offer.oc_buy_no_of_ticket) {
            let offerFnbItem = this.fnbItems.filter(
              (x) => x.item_code == offer.oc_get_item_code
            );

            let getItemCount = 0;
            selectedFnbItems.forEach((x) => {
              if (
                x.item_id == offer.oc_get_item_id ||
                x.item_code == offer.oc_get_item_code
              ) {
                getItemCount += x.quantity;
              }
            });
            let totalFreeItemQty = 0;
            if (
              offer.oc_buy_no_of_ticket == offer.oc_get_item_count &&
              offer.oc_buy_item_count > 1
            ) {
              totalFreeItemQty = parseInt(
                Math.floor(
                  TotalSeats /
                    parseInt(
                      offer.oc_buy_no_of_ticket + offer.oc_get_item_count
                    )
                ) * offer.oc_get_item_count
              );
            } else {
              totalFreeItemQty = parseInt(
                Math.floor(TotalSeats / parseInt(offer.oc_buy_no_of_ticket)) *
                  offer.oc_get_item_count
              );
            }

            if (offerFnbItem.length > 0) {
              let itemQty = totalFreeItemQty || 1;
              let checkAlreadyAddedItem = selectedFnbItems.findIndex(
                (x) => x.item_code == offer.oc_get_item_code
              );
              if (checkAlreadyAddedItem > -1) {
                if (selectedFnbItems[checkAlreadyAddedItem].Qty == itemQty) {
                  // DO NOTHING
                } else {
                  selectedFnbItems[checkAlreadyAddedItem].Qty += itemQty;
                }
              } else {
                let fnbObj = {
                  ...offerFnbItem[0],
                  Qty: itemQty,
                };
                selectedFnbItems.push(fnbObj);
              }
              this.finalCalculationFnb(selectedFnbItems);
            } else {
              this.removeAddedOffer();
            }
          } else {
            this.removeAddedOffer();
            console.log(
              "Please select atleast " +
                offer.oc_buy_no_of_ticket +
                " ticket(s)"
            );
          }
        } else if (
          offer.oc_is_combo == "Y" &&
          offer.oc_is_combo_free == "Y" &&
          offer.oc_is_combo_with_fnb == "Y"
        ) {
          let array = selectedFnbItems.filter((singleItem) => {
            return (
              (singleItem.item_id == offer.oc_buy_item_id ||
                singleItem.item_code == offer.oc_buy_item_code) &&
              singleItem.Qty >= offer.oc_buy_item_count
            );
          });
          let toBuyItem = this.fnbItems.filter(
            (x) =>
              x.item_id == offer.oc_buy_item_id ||
              x.item_code == offer.oc_buy_item_code
          );
          let offerFnbItemIndex = selectedFnbItems.findIndex(
            (fnbItem) =>
              (offer.oc_get_item_code &&
                fnbItem.item_code == offer.oc_get_item_code) ||
              fnbItem.item_id == offer.oc_get_item_id
          );
          let itemCount = 0;
          selectedFnbItems.forEach((x) => {
            if (
              x.item_id == offer.oc_buy_item_id ||
              x.item_code == offer.oc_buy_item_code
            ) {
              itemCount += x.quantity;
            }
          });

          let totalFreeItemQty = 0;
          if (
            offer.oc_buy_item_count == offer.oc_get_item_count &&
            offer.oc_buy_item_count > 1
          ) {
            totalFreeItemQty = parseInt(
              Math.floor(
                itemCount /
                  parseInt(offer.oc_buy_item_count + offer.oc_get_item_count)
              ) * offer.oc_get_item_count
            );
          } else {
            totalFreeItemQty = parseInt(
              Math.floor(itemCount / parseInt(offer.oc_buy_item_count)) *
                offer.oc_get_item_count
            );
          }

          if (array && array.length > 0) {
            let offerFnbItem = this.fnbItems.filter(
              (x) =>
                (offer.oc_get_item_code &&
                  x.item_code == offer.oc_get_item_code) ||
                x.item_id == offer.oc_get_item_id
            );
            let getItemCount = 0;
            selectedFnbItems.forEach((x) => {
              if (
                x.item_id == offer.oc_get_item_id ||
                x.item_code == offer.oc_get_item_code
              ) {
                getItemCount += x.quantity;
              }
            });
            if (offerFnbItem.length > 0) {
              let itemQty = totalFreeItemQty || 1;
              let checkAlreadyAddedItem = selectedFnbItems.findIndex(
                (x) => x.item_code == offer.oc_get_item_code
              );
              if (checkAlreadyAddedItem > -1) {
                if (selectedFnbItems[checkAlreadyAddedItem].Qty == itemQty) {
                  // DO NOTHING
                } else {
                  selectedFnbItems[checkAlreadyAddedItem].Qty += itemQty;
                }
              } else {
                let fnbObj = {
                  ...offerFnbItem[0],
                  Qty: itemQty,
                };
                selectedFnbItems.push(fnbObj);
              }
              this.finalCalculationFnb(selectedFnbItems);
            } else {
              this.removeAddedOffer();
              console.log("NO FNB ITEM FOUND");
            }
          } else {
            let offerFnbItem = this.fnbItems.filter(
              (x) =>
                (offer.oc_get_item_code &&
                  x.item_code == offer.oc_get_item_code) ||
                x.item_id == offer.oc_get_item_id
            );
            let msg = `Offer not applicable on selected items`;
            if (toBuyItem && toBuyItem.length > 0) {
              msg =
                "Offer is applicable on puchasing" +
                offer.oc_buy_item_count +
                " " +
                toBuyItem[0].item_name;
            }
            this.removeAddedOffer();
          }
        } else if (
          offer.oc_is_combo == "Y" &&
          offer.oc_is_combo_free == "N" &&
          offer.oc_is_combo_with_fnb == "Y"
        ) {
          let array = selectedFnbItems.filter((singleItem) => {
            return (
              (singleItem.item_id == offer.oc_buy_item_id ||
                singleItem.item_code == offer.oc_buy_item_code) &&
              singleItem.quantity >= offer.oc_buy_item_count
            );
          });
          let toBuyItem = this.fnbItems.filter(
            (x) =>
              x.item_id == offer.oc_buy_item_id ||
              x.item_code == offer.oc_buy_item_code
          );
          let offerFnbItemIndex = selectedFnbItems.findIndex(
            (fnbItem) =>
              (offer.oc_get_item_code &&
                fnbItem.item_code == offer.oc_get_item_code) ||
              fnbItem.item_id == offer.oc_get_item_id
          );
          let itemCount = 0;
          selectedFnbItems.forEach((x) => {
            if (
              x.item_id == offer.oc_buy_item_id ||
              x.item_code == offer.oc_buy_item_code
            ) {
              itemCount += x.quantity;
            }
          });

          let totalFreeItemQty = 0;
          if (
            offer.oc_buy_item_count == offer.oc_get_item_count &&
            offer.oc_buy_item_count > 1
          ) {
            totalFreeItemQty = parseInt(
              Math.floor(
                itemCount /
                  parseInt(offer.oc_buy_item_count + offer.oc_get_item_count)
              ) * offer.oc_get_item_count
            );
          } else {
            totalFreeItemQty = parseInt(
              Math.floor(itemCount / parseInt(offer.oc_buy_item_count)) *
                offer.oc_get_item_count
            );
          }

          if (array && array.length > 0) {
            let offerFnbItem = this.fnbItems.filter(
              (x) =>
                (offer.oc_get_item_code &&
                  x.item_code == offer.oc_get_item_code) ||
                x.item_id == offer.oc_get_item_id
            );
            let getItemCount = 0;
            selectedFnbItems.forEach((x) => {
              if (
                x.item_id == offer.oc_get_item_id ||
                x.item_code == offer.oc_get_item_code
              ) {
                getItemCount += x.quantity;
              }
            });
            if (offerFnbItem.length > 0) {
              let itemQty = totalFreeItemQty || 1;
              let checkAlreadyAddedItem = selectedFnbItems.findIndex(
                (x) => x.item_code == offer.oc_get_item_code
              );
              if (checkAlreadyAddedItem > -1) {
                if (selectedFnbItems[checkAlreadyAddedItem].Qty == itemQty) {
                  // DO NOTHING
                } else {
                  selectedFnbItems[checkAlreadyAddedItem].Qty += itemQty;
                }
              } else {
                let fnbObj = {
                  ...offerFnbItem[0],
                  Qty: itemQty,
                };
                selectedFnbItems.push(fnbObj);
              }
              this.finalCalculationFnb(selectedFnbItems);
            } else {
              this.removeAddedOffer();
              console.log("NO FNB ITEM FOUND");
            }
          } else {
            this.removeAddedOffer();
            let msg = `Offer not applicable on selected items`;
            if (toBuyItem && toBuyItem.length > 0) {
              msg =
                "Offer is applicable on puchasing" +
                offer.oc_buy_item_count +
                " " +
                toBuyItem[0].item_name;
            }
          }
        }
      }
    },
    finalCalculationFnb(selectedFnbItems) {
      let FinalFNBArray = [];
      if (selectedFnbItems.length > 0) {
        selectedFnbItems.forEach((x) => {
          let TotalPrice = +parseFloat(x.fp_total_amount).toFixed(4) * x.Qty;
          let TotalTax =
            +parseFloat(x.fp_total_amount - x.fp_amount).toFixed(4) * x.Qty;

          this.FNbPrice["total_price"] = +parseFloat(
            this.FNbPrice["total_price"] + TotalPrice
          ).toFixed(4);
          this.FNbPrice["total_tax"] = +parseFloat(
            this.FNbPrice["total_tax"] + TotalTax
          ).toFixed(4);
          let obj = {
            ...x,
            Quantity: x.Qty,
            quantity: x.Qty,
            total_price: TotalPrice,
            total_tax: TotalTax,
          };
          FinalFNBArray.push(obj);
          this.totalAmount = +parseFloat(
            parseFloat(this.totalAmount) + parseFloat(TotalPrice)
          ).toFixed(4);
        });
        this.onUpdateFnbCartItems(FinalFNBArray);
      }
    },
    onUpdateFnbCartItems: function(fnbItems) {
      this.showLoading();
      let payload = {
        reservation_id: this.ReserveID,
        selected_fnb_items: fnbItems,
        fnb_price: this.FNbPrice,
        category_id: 2,
      };

      makeRequestBrij("/api/external/save-fnb-items", "POST", null, payload)
        .then((result) => {
          const { error, res } = result;
          const { data } = res.data;
          if (!error && res.data.status) {
            this.hideLoading();
          } else {
            // show error modal
            this.$root.$emit("bv::show::modal", "errorModal");
          }
          this.hideLoading();
        })
        .catch((error) => {
          this.hideLoading();
          console.log("Error on vue front", error);
        })
        .finally(() => {
          this.getReserveInfo(this.ReserveID, false);
        });
    },
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/components/pages/confirmationNew.vue